var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPatumInfantil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 782.55",
    style: {
      enableBackground: "new 0 0 841.89 782.55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1067AB;}\n\t.st1{fill:#F8E81F;}\n\t.st2{fill:#E10D17;}\n\t.st3{fill:#C6A107;}\n\t.st4{fill:#EFBF11;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#077F36;}\n\t.st7{fill:#134321;}\n\t.st8{fill:#BE1622;}\n\t.st9{fill:#F6F6F6;}\n\t.st10{opacity:0.2;}\n\t.st11{fill:#030405;}\n\t.st12{fill:#C5A206;}\n\t.st13{fill:#FAE81E;}\n\t.st14{fill:#E3101A;}\n\t.st15{fill:#898621;}\n\t.st16{fill:#528A31;}\n\t.st17{fill:#64B572;}\n\t.st18{fill:#228C37;}\n\t.st19{fill:#778928;}\n\t.st20{fill:#81B76B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_997_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1042_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1611_",
    x: 426.57,
    y: 200.81,
    className: "st0",
    width: 170.26,
    height: 205.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1041_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1609_",
    className: "st0",
    points: "426.57,613.68 395.49,599.13 255.69,599.13 255.69,405.84 425.95,405.84  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1035_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1040_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1607_",
    x: 255.06,
    y: 200.81,
    className: "st1",
    width: 171.51,
    height: 202.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1039_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1605_",
    x: 274.8,
    y: 197.48,
    className: "st2",
    width: 21.2,
    height: 206.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1038_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1603_",
    x: 312.69,
    y: 197.48,
    className: "st2",
    width: 21.2,
    height: 206.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1037_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1601_",
    x: 350.58,
    y: 197.48,
    className: "st2",
    width: 21.2,
    height: 206.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1036_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1599_",
    x: 388.47,
    y: 197.48,
    className: "st2",
    width: 21.2,
    height: 206.12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1029_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1034_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1596_",
    className: "st1",
    points: "596.83,599.13 455.66,600.58 428.86,610.87 425.32,406.76 596.83,406.76  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1033_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1594_",
    x: 445.06,
    y: 403.6,
    className: "st2",
    width: 21.2,
    height: 195.52
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1032_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1592_",
    x: 482.95,
    y: 403.6,
    className: "st2",
    width: 21.2,
    height: 195.52
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1590_",
    x: 520.85,
    y: 403.6,
    className: "st2",
    width: 21.2,
    height: 195.52
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1030_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1588_",
    x: 558.74,
    y: 403.6,
    className: "st2",
    width: 21.2,
    height: 195.52
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1028_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_960_",
    className: "st3",
    d: "M428.47,629.85l-29.91-24.49H270.03c-11.69,0-21.2-9.39-21.2-20.93V212.17 c0-11.54,9.51-20.93,21.2-20.93h313.08c11.69,0,21.2,9.39,21.2,20.93v372.26c0,11.54-9.51,20.93-21.2,20.93H454.8L428.47,629.85z  M270.03,203.72c-4.81,0-8.73,3.79-8.73,8.46v372.26c0,4.66,3.92,8.46,8.73,8.46h132.99l24.93,20.41l21.95-20.41h133.21 c4.81,0,8.73-3.79,8.73-8.46V212.17c0-4.66-3.92-8.46-8.73-8.46L270.03,203.72L270.03,203.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1010_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1027_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1581_",
    className: "st4",
    d: "M251.02,190.83c0.89-7.98,1.42-16.98,1.25-26.82c-0.12-6.92-0.59-13.39-1.25-19.33 c-30.35-20.79-60.7-41.58-91.06-62.37c1.53-1.7,9.88-10.6,23.7-11.23c14.88-0.67,24.42,8.79,25.88,10.29 c18.98-7.68,35.64-0.22,38.36,9.04c2,6.8-3.13,15.91-11.54,22.45c3.9,2.37,8.67,4.68,14.31,6.32 c21.33,6.23,40.23-1.39,47.37-4.74c2.93-1.03,9.57-3.83,14.8-10.66c3.35-4.38,4.84-8.73,5.54-11.51 c2.27,1.79,6.04,4.38,11.23,6.24c3.34,1.19,18.57,6.12,32.43-2.49c6.54-4.06,10.35-9.63,12.47-13.72 c0.98,1.78,3.57,5.9,8.73,8.73c6.03,3.31,11.79,2.76,13.72,2.49c3.65-0.26,9.03-1.08,14.97-3.74 c8.38-3.76,13.6-9.26,16.22-12.47c1.48,2.46,3.68,5.49,6.86,8.42c6.27,5.77,13.02,8.07,16.84,9.04 c2.55,0.23,9.63,0.51,16.78-3.82c4.95-3,7.76-6.9,9.11-9.11c0.32,1.85,1.49,7.29,6.28,11.93c5.06,4.91,10.92,5.79,12.74,5.99 c4.42,0,10.24-0.45,16.84-2.18c7.85-2.07,13.94-5.22,18.09-7.8c0.78,2.15,5.75,15.21,20.2,21.31c14.67,6.2,27.69,0.4,29.73-0.55 c3.69,11.3,13.74,19.07,24.91,19.46c14.08,0.5,22.46-10.97,23.08-11.85c-0.7,0.18-16.64,4.12-24.64-4.68 c-9.75-10.73-2.72-34.99,12.47-39.29c8.35-2.36,18.19,1.58,25.26,9.36c0.73-1.11,9.41-13.85,24.64-14.03 c12.69-0.15,24.54,8.49,29,21.52c-31.18,18.71-62.37,37.42-93.55,56.13c-1.1,5.68-1.99,12.4-2.18,19.96 c-0.26,10.24,0.81,19.12,2.18,26.19c-31.01-15.84-85.16-38.36-155.92-42.41C354.67,145.64,284.14,174.58,251.02,190.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1026_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1579_",
    className: "st4",
    d: "M274.09,57.36c-1.84,1.19-10.27,6.93-11.85,17.15c-1.98,12.86,8.13,24.66,18.4,28.07 c6.6,2.19,16.48,1.99,22.45-1.87c1.27-0.82,4.95-3.47,10.6-4.99c1.74-0.47,3.22-0.71,4.22-0.84c0.9-1.11,2.48-2.86,4.83-4.47 c10.45-7.15,20.07-0.37,27.44-5.92c6.6-4.98,6.15-15.9,5.92-21.52c-0.24-5.9-0.56-13.75-6.55-18.71 c-5.75-4.76-14.62-5.12-22.76-1.56c-1.1-2.58-5.75-12.62-16.84-17.15c-10.19-4.17-25.6-3.6-33.37,7.17 C269.15,43.04,273.58,55.95,274.09,57.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1025_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1577_",
    className: "st4",
    d: "M405.69,42.18c-2.29-0.25-12.16-1.08-18.29,5.28c-8.92,9.26-4.52,28.18,6.23,35.47 c7.44,5.04,16.5,3.55,19.13,3.12c7.62-1.25,12.83-5.09,15.18-7.07c1.59,1.19,4.04,2.81,7.28,4.16 c9.95,4.13,19.16,2.24,23.7,1.25c7.99-1.75,13.71-3.01,17.67-8.32c4.43-5.94,5.97-16.04,0.21-23.7 c-4.75-6.32-13.09-9.14-21.01-7.07c0.1-1.61,0.63-12.9-8.17-21.19c-0.49-0.46-11.6-10.57-25.08-6.04 C412.67,21.38,405.82,31.08,405.69,42.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1024_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1575_",
    className: "st4",
    d: "M518.89,49.13c-2.17-0.78-11.58-3.89-19.02,0.87c-10.83,6.93-10.96,26.35-2.2,35.94 c6.06,6.64,15.22,7.3,17.87,7.49c7.71,0.56,13.66-1.96,16.41-3.34c1.27,1.53,3.27,3.68,6.11,5.74 c8.72,6.34,18.11,6.65,22.76,6.73c8.18,0.16,14.03,0.27,19.12-3.97c5.69-4.75,9.54-14.21,5.72-23 c-3.15-7.25-10.6-11.94-18.79-11.77c0.47-1.54,3.62-12.4-3.01-22.51c-0.37-0.56-8.81-12.98-22.98-11.72 C530.53,30.53,521.61,38.36,518.89,49.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1023_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_566_",
    className: "st3",
    cx: 210.26,
    cy: 103.98,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1022_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_571_",
    className: "st3",
    cx: 309.1,
    cy: 70.02,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1021_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_593_",
    className: "st3",
    cx: 272.59,
    cy: 157.56,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1020_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_594_",
    className: "st3",
    cx: 338.69,
    cy: 137.61,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1019_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_595_",
    className: "st3",
    cx: 426.57,
    cy: 128.56,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1018_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_756_",
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 297.5778 625.5808)",
    className: "st3",
    cx: 516.43,
    cy: 137.91,
    rx: 10.6,
    ry: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1017_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_757_",
    className: "st3",
    cx: 582.49,
    cy: 157.56,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1016_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_758_",
    className: "st3",
    cx: 431.57,
    cy: 58.92,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1015_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_759_",
    className: "st3",
    cx: 537.63,
    cy: 70.02,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1014_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_765_",
    className: "st3",
    cx: 654.32,
    cy: 103.98,
    r: 10.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1013_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1553_",
    className: "st3",
    d: "M250.8,144.47c0.42,3.26,0.83,6.51,1.25,9.77c33.48-15.31,96.15-38.68,177.75-38.25 c78.13,0.41,138.35,22.45,171.51,37.42c0.35-2.36,0.69-4.71,1.04-7.07c-31.92-15.54-93.66-40.42-175.04-40.95 C345.35,104.84,282.93,129.25,250.8,144.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1012_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1551_",
    className: "st3",
    d: "M252.26,178.56c-0.49,4.09-0.97,8.18-1.46,12.27c32.04-15.33,95.54-40.49,178.99-39.29 c80.48,1.16,141.39,26.29,172.96,41.99c-0.6-5.27-1.2-10.55-1.8-15.82c-33.49-14.87-94.53-36.83-173.66-36.78 C347.33,140.98,285.77,163.48,252.26,178.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1011_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1549_",
    className: "st3",
    d: "M599.02,146.96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1009_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_959_",
    x: 420.34,
    y: 193.53,
    className: "st3",
    width: 12.47,
    height: 420.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1008_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_957_",
    x: 255.06,
    y: 399.34,
    className: "st3",
    width: 347.28,
    height: 12.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1542_",
    className: "st5",
    d: "M272.63,564.84c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C285.16,542.1,274.72,551.92,272.63,564.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1006_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1540_",
    className: "st5",
    d: "M354.47,564.84c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C367,542.1,356.56,551.92,354.47,564.84z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1005_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1538_",
    className: "st5",
    d: "M272.63,461.86c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C285.16,439.12,274.72,448.94,272.63,461.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1004_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1536_",
    className: "st5",
    d: "M354.47,461.86c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C367,439.12,356.56,448.94,354.47,461.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1003_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1534_",
    className: "st5",
    d: "M314.56,506.77c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C327.09,484.03,316.64,493.85,314.56,506.77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1002_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1532_",
    className: "st5",
    d: "M442.89,357.78c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C455.42,335.04,444.98,344.86,442.89,357.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1001_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1530_",
    className: "st5",
    d: "M524.74,357.78c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C537.27,335.04,526.82,344.86,524.74,357.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1528_",
    className: "st5",
    d: "M442.89,254.8c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C455.42,232.06,444.98,241.88,442.89,254.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_999_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1526_",
    className: "st5",
    d: "M524.74,254.8c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C537.27,232.06,526.82,241.88,524.74,254.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_998_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1524_",
    className: "st5",
    d: "M484.82,299.71c3.51-2.54,12.24-8.12,24.71-8.8c15.52-0.85,26.55,6.46,29.82,8.8 c-0.76-2.84-1.51-5.68-2.27-8.52c-5.31-10.26-16.16-16.33-27.26-15.34C497.35,276.97,486.91,286.79,484.82,299.71z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_895_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_996_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1521_",
    className: "st6",
    d: "M343.45,323.64c16.23-3.61,34.51-6.6,54.58-8.15c45.63-3.52,84.95,1.57,114.87,8.15 c11.55-0.86,22.1,4.22,26.88,13.03c3.41,6.29,2.88,12.61,2.44,15.48c1.09,14.12,2.17,28.24,3.26,42.36 c4.73,0.89,13.44,3.29,20.37,10.59c9.28,9.78,9.53,22.22,9.78,34.22c0.22,11.08,0.5,24.68-8.96,36.66 c-6.55,8.3-14.87,12.13-19.55,13.85c0.66,11.16-0.06,29.69-11.41,45.62c-20.03,28.13-59.35,28.74-97.76,29.33 c-37.62,0.58-66.42,1.02-88.8-20.37c-20.68-19.77-24.13-46.96-24.88-58.65c-4.18,0.11-11.25-0.4-17.48-4.89 c-9.43-6.79-10.8-18.28-12.22-30.14c-1.52-12.75-3.31-27.71,6.52-39.92c6.11-7.59,14.11-10.87,18.74-12.32 c-1.57-8.04-4.41-28.51,5.81-50.41C331.01,336.57,338.16,328.58,343.45,323.64z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_995_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_766_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1518_",
    className: "st5",
    d: "M455.36,433.67c0.5-1.72,0.74-2.58,1.36-3.59c1.7-2.79,4.08-4.56,4.43-4.81 c2.76-2.01,10.52-6.3,21.38-5.5c3.42,0.25,8.34,0.67,13.14,3.97c4.57,3.15,6.07,6.89,6.27,8.7c0.06,0.5,0.21,1.78-0.56,2.69 c-0.5,0.59-1.18,0.85-1.83,0.99c-2.8,0.63-5.51-0.44-5.57-0.46c-3.76-1.48-14.28-5.62-21.75-3.26 c-4.35,1.38-6.41,4.57-12.24,4.56c-1.13,0-2.05-0.12-2.67-0.23c-0.28-0.03-1.5-0.18-1.99-1.07 C455.1,435.21,455.06,434.7,455.36,433.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_994_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_767_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1515_",
    className: "st5",
    d: "M354.93,433.67c0.5-1.72,0.74-2.58,1.36-3.59c1.7-2.79,4.08-4.56,4.43-4.81 c2.76-2.01,10.52-6.3,21.38-5.5c3.42,0.25,8.34,0.67,13.14,3.97c4.57,3.15,6.07,6.89,6.27,8.7c0.06,0.5,0.21,1.78-0.56,2.69 c-0.5,0.59-1.18,0.85-1.83,0.99c-2.8,0.63-5.51-0.44-5.57-0.46c-3.76-1.48-14.28-5.62-21.75-3.26 c-4.35,1.38-6.41,4.57-12.24,4.56c-1.13,0-2.05-0.12-2.67-0.23c-0.28-0.03-1.5-0.18-1.99-1.07 C354.67,435.21,354.63,434.7,354.93,433.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_987_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_938_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_769_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_770_",
    className: "st7",
    d: "M351.72,398.93c8.4-1.14,16.84-1.94,25.31-2.31c8.3-0.37,17.85-1.26,25.74,2.02 c12.9,5.36,9.08,25.34,8.93,36.89c-0.18,13.73-2.41,27.29-2.89,40.98c-0.2,5.77,1.22,10.58,5.05,15.01 c3.17,3.66,7.48,5.1,12.15,5.78c6.04,0.87,13.51,1.71,19.34-0.6c8.65-3.43,6.71-12.14,5.53-19.57 c-2.53-15.99-4.13-31.33-4.76-47.56c-0.3-7.8-2.37-18.11,0.68-25.57c3.15-7.7,11.37-9.49,18.82-10.18 c15.59-1.45,31.36,0.36,46.57,3.77c-0.95-0.21-1.57-4.92-3.28-5.3c-13.85-3.11-28-4.8-42.21-4.07 c-5.89,0.3-12.68,0.62-17.78,3.95c-5.62,3.67-6.71,9.68-6.64,15.91c0.17,15.99,0.48,32.42,2.66,48.3 c0.92,6.67,2.38,13.27,3.23,19.95c0.45,3.49,1.14,7.74-0.76,10.94c-5.08,8.57-25.88,6.55-32.94,2.17 c-0.84-0.66-1.68-1.33-2.52-1.99c0.84,1.61,1.01,1.69,0.51,0.24c0.1-0.61-0.25-1.68-0.31-2.31c-0.14-1.65-0.04-3.33,0.05-4.98 c0.36-6.87,1.29-13.71,1.87-20.56c1.05-12.45,1.35-25.11,1.16-37.61c-0.16-10.41-3.82-22.83-13.8-28.03 c-6.95-3.63-15.47-3.23-23.06-3.03c-10.02,0.26-20,1.13-29.93,2.47C348.74,393.59,350.43,399.11,351.72,398.93L351.72,398.93z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_980_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_771_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_772_",
    className: "st8",
    d: "M467.55,463.67c18.96,2.7,37.92,0.87,55.99-5.5c8.64-3.05,1.49-16.82-6.64-13.96 c-15.75,5.55-32.29,7.24-48.83,4.88C458.23,447.7,458.88,462.44,467.55,463.67L467.55,463.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_973_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_888_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_773_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_774_",
    className: "st8",
    d: "M334.15,462.53c22.85,6.3,46.49,6.37,69.25-0.38c9.18-2.73-1.13-12.96-7.93-10.94 c-18.87,5.6-38.75,6.1-57.77,0.86c-3.04-0.84-7.9-0.98-9.16,2.73C327.36,458.26,331.15,461.7,334.15,462.53L334.15,462.53z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_966_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_775_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_776_",
    className: "st8",
    d: "M363.57,365.33c47.08,6.01,95.06,5.91,142.09-0.55c10.09-1.39,3.32-12.62-4.39-11.56 c-45.79,6.29-92.36,6.55-138.2,0.69C352.9,352.61,354.98,364.23,363.57,365.33L363.57,365.33z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_965_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1496_",
    className: "st9",
    d: "M378.94,504.14c22.93,7.69,41.49,8.78,53.13,8.56c12.83-0.24,20.03-0.38,29.8-2.97 c9.36-2.49,18.97-3.92,28.41-6.11c3.4-0.79,7.94-1.86,11.61,0.61c4.01,2.7,4.72,8.11,4.89,10.39c-0.8,1.74-2.2,4.28-4.58,6.72 c-4.38,4.5-9.83,6.37-24.74,8.86c-11.91,1.99-20.97,2.89-22.61,3.05c-9.24,0.9-20.15,1.73-24.44,1.83 c-21.24,0.51-44.8-12.73-59.03-22.16c-1.6-1.92-2.07-4.46-1.15-6.41C371.53,503.79,375.44,502.41,378.94,504.14z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_958_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_886_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_779_",
    className: "st8",
    d: "M396.33,543.8c0.37,5.4,0.75,10.8,1.12,16.2c0.41,5.97,9.77,6.02,9.36,0 c-0.37-5.4-0.75-10.8-1.12-16.2C405.27,537.83,395.91,537.78,396.33,543.8L396.33,543.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_951_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_780_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_781_",
    className: "st8",
    d: "M417.73,544.56c-0.34,5.52-0.68,11.04-1.02,16.56c-0.37,6.01,8.98,5.99,9.36,0 c0.34-5.52,0.68-11.04,1.02-16.56C427.46,538.55,418.1,538.57,417.73,544.56L417.73,544.56z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_944_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_884_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    className: "st8",
    d: "M438.75,544.73c-0.53,5.42-0.5,10.81,0.11,16.22c0.29,2.53,1.95,4.65,4.68,4.68 c2.31,0.02,4.96-2.17,4.68-4.68c-0.61-5.41-0.65-10.8-0.11-16.22C448.7,538.75,439.34,538.79,438.75,544.73L438.75,544.73z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_937_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_784_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_785_",
    className: "st8",
    d: "M462.25,541.92c-0.04,2.89,0.11,5.74,0.49,8.61c0.32,2.47,1.61,5.76,1.26,8.23 c-0.36,2.52,0.62,4.99,3.27,5.75c2.19,0.63,5.4-0.77,5.75-3.27c0.91-6.37-1.51-12.85-1.41-19.32 C471.7,535.9,462.34,535.9,462.25,541.92L462.25,541.92z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_936_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_905_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_786_",
    className: "st11",
    d: "M352.47,396.27c-4.39,1.52-8,5.15-9.49,9.56c-0.64,1.89-0.8,4.24,0.65,5.62 c1.13,1.08,2.86,1.19,4.43,1.15c9.43-0.21,18.62-3.06,28.03-3.72s19.88,1.43,25.67,8.88c3.97,5.11,5.05,11.84,5.71,18.27 c0.87,8.47,1.22,17.08-0.28,25.47c-1.86,10.35-6.22,22.12,0.13,30.51c4.26,5.62,12.95,7.26,18.96,3.58 c-4.09-3.27-9.79-4.34-13.26-8.26c-4.15-4.7-3.7-11.76-2.99-17.99c1.48-13.2,2.97-26.4,4.45-39.6 c0.66-5.87,1.32-11.85,0.29-17.67s-4-11.57-9.09-14.59c-4.87-2.88-10.86-2.88-16.52-2.72c-11.83,0.33-23.66,0.99-35.45,1.96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_935_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    className: "st11",
    d: "M320.32,400.62c4.14,29.05,6.46,58.36,6.94,87.69c-1.92-6.48-7.23-11.3-10.73-17.07 c-8.2-13.49-5.96-30.69-2.51-46.09c1.8-8.05,3.86-16.05,6.18-23.97"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_934_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_788_",
    className: "st11",
    d: "M544.44,398.93c5.71,29.03,3.5,58.96,1.26,88.45c17.64-25.59,17.38-62.21-0.61-87.55"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_933_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_902_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_789_",
    className: "st11",
    d: "M445.6,415.19c5.43-8.47,16.64-10.9,26.68-11.44c8.24-0.45,16.51-0.14,24.69,0.92 c3.4,0.44,7,0.99,10.14-0.39s5.29-5.56,3.29-8.34c-1.23-1.71-3.49-2.27-5.57-2.66c-10.81-2.05-21.84-2.96-32.84-2.7 c-7.56,0.18-15.71,1.15-21.27,6.27c-4.91,4.51-6.85,11.98-4.78,18.32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_922_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_932_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_790_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1465_",
    className: "st11",
    d: "M309.36,144.25l-0.24,35.55l11.37,17.75c-0.7,1.32-4.18,8.15-2.15,16.65 c1.42,5.96,4.8,9.55,6.18,10.87c7.61,34.12,15.23,68.25,22.84,102.37l15.97-6.38l-28.68-99.48c0.65-2.41,1.58-7.14,0.52-12.89 c-1.58-8.55-6.52-13.61-8.17-15.17c0.85-6.78,1.71-13.57,2.56-20.35L309.36,144.25z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_925_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_929_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_792_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_793_",
    className: "st12",
    d: "M394.53,278.78c0,31.94-25.9,57.84-57.84,57.84s-57.84-25.9-57.84-57.84 s25.9-57.84,57.84-57.84S394.53,246.84,394.53,278.78z M336.69,236.35c-25.99,0-47.06,21.07-47.06,47.06 c0,25.99,21.07,47.06,47.06,47.06s47.06-21.07,47.06-47.06C383.75,257.42,362.68,236.35,336.69,236.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_926_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_794_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    className: "st12",
    d: "M387.4,283.41c0,23.96-19.42,43.38-43.38,43.38s-43.38-19.42-43.38-43.38 s19.42-43.38,43.38-43.38C367.98,240.04,387.4,259.46,387.4,283.41z M344.02,251.59c-19.49,0-35.3,15.8-35.3,35.3 s15.8,35.3,35.3,35.3s35.3-15.8,35.3-35.3S363.52,251.59,344.02,251.59z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_924_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1451_",
    className: "st11",
    d: "M363.47,244.45c0.21-0.31-1.17-1.73-3.04-3.17c-2.06-1.59-8.86-5.73-23.99-7.32 c-3.58-0.38-7.21-0.46-10.78,0.03c-11.5,1.56-21.57,8.95-28.81,18.02c-3.46,4.33-10.67,13.34-11.79,26.98 c-0.37,4.52-0.96,20.27,10.22,32.16c3.59,3.81,7.34,6.11,9.88,7.43c-3.49-3.21-9.44-9.6-12.93-19.45c0,0-2.56-7.22-2.75-17.01 c-0.13-6.63,1.26-10.59,1.63-11.81l0,0c0.59-1.98,1.26-3.69,1.94-5.16c0.08-0.18,0.86-1.91,1.93-3.8 c3.05-5.39,7.18-9.8,7.18-9.8c2.08-2.23,6.68-7.04,14.31-10.67c7.52-3.58,14.08-4.14,17.2-4.37c1.81-0.14,4.45-0.32,7.76,0 C354.05,237.75,362.97,245.21,363.47,244.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_923_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_900_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1448_",
    className: "st11",
    d: "M376.2,272.27c0.09-1.28,0.06-3.33-0.81-5.55c-0.62-1.58-1.51-2.86-3.56-4.97 c-4.76-4.92-9.34-7.72-10.25-8.27c-1.38-0.83-4.28-2.64-7.34-3.71c-8.36-2.93-17.75-1.43-25.79,2.18 c-3.75,1.69-11.73,5.28-17.28,14.12c-1.45,2.31-7.96,13.3-4.34,26.48c1.57,5.71,4.47,9.75,6.36,11.99 c-1.38-2.71-3.06-6.76-3.86-11.92c-0.65-4.18-0.51-7.79-0.21-10.48c0.07-0.96,0.22-2.29,0.56-3.84 c0.87-4.01,2.42-6.82,3.41-8.59c1.91-3.39,3.94-5.72,5-6.85c0.56-0.6,2.57-2.7,5.7-4.9c1.94-1.36,4.7-3.04,8.28-4.44 c6.04-2.36,11.3-1.99,13.65-1.86c2.36,0.13,7.25,0.63,12.55,2.98c0.96,0.42,3.34,1.53,6.11,3.44c0.28,0.19,2.21,1.52,3.93,3.09 C372.36,264.84,374.86,269.41,376.2,272.27z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_911_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_921_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_791_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1444_",
    className: "st11",
    d: "M535.1,144.25l0.24,35.55l-11.37,17.75c0.7,1.32,4.18,8.15,2.15,16.65 c-1.42,5.96-4.8,9.55-6.18,10.87c-7.61,34.12-15.23,68.25-22.84,102.37l-15.97-6.38l28.68-99.48 c-0.65-2.41-1.58-7.14-0.52-12.89c1.58-8.55,6.52-13.61,8.17-15.17c-0.85-6.78-1.71-13.57-2.56-20.35L535.1,144.25z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_914_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_918_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_798_",
    className: "st12",
    d: "M507.77,220.94c31.94,0,57.84,25.9,57.84,57.84s-25.9,57.84-57.84,57.84 s-57.84-25.9-57.84-57.84S475.82,220.94,507.77,220.94z M460.71,283.41c0,25.99,21.07,47.06,47.06,47.06 c25.99,0,47.06-21.07,47.06-47.06s-21.07-47.06-47.06-47.06S460.71,257.42,460.71,283.41z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_915_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_799_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_800_",
    className: "st12",
    d: "M500.43,240.04c23.96,0,43.38,19.42,43.38,43.38s-19.42,43.38-43.38,43.38 c-23.96,0-43.38-19.42-43.38-43.38C457.06,259.46,476.48,240.04,500.43,240.04z M465.14,286.89c0,19.49,15.8,35.3,35.3,35.3 s35.3-15.8,35.3-35.3s-15.8-35.3-35.3-35.3S465.14,267.4,465.14,286.89z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_913_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_899_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1430_",
    className: "st11",
    d: "M480.99,244.45c-0.21-0.31,1.17-1.73,3.04-3.17c2.06-1.59,8.86-5.73,23.99-7.32 c3.58-0.38,7.21-0.46,10.78,0.03c11.5,1.56,21.57,8.95,28.81,18.02c3.46,4.33,10.67,13.34,11.79,26.98 c0.37,4.52,0.96,20.27-10.22,32.16c-3.59,3.81-7.34,6.11-9.88,7.43c3.49-3.21,9.44-9.6,12.93-19.45c0,0,2.56-7.22,2.75-17.01 c0.13-6.63-1.26-10.59-1.63-11.81l0,0c-0.59-1.98-1.26-3.69-1.94-5.16c-0.08-0.18-0.86-1.91-1.93-3.8 c-3.05-5.39-7.18-9.8-7.18-9.8c-2.08-2.23-6.68-7.04-14.31-10.67c-7.52-3.58-14.08-4.14-17.2-4.37c-1.81-0.14-4.45-0.32-7.76,0 C490.41,237.75,481.49,245.21,480.99,244.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_912_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_898_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1427_",
    className: "st11",
    d: "M468.26,272.27c-0.09-1.28-0.06-3.33,0.81-5.55c0.62-1.58,1.51-2.86,3.56-4.97 c4.76-4.92,9.34-7.72,10.25-8.27c1.38-0.83,4.28-2.64,7.34-3.71c8.36-2.93,17.75-1.43,25.79,2.18 c3.75,1.69,11.73,5.28,17.28,14.12c1.45,2.31,7.96,13.3,4.34,26.48c-1.57,5.71-4.47,9.75-6.36,11.99 c1.38-2.71,3.06-6.76,3.86-11.92c0.65-4.18,0.51-7.79,0.21-10.48c-0.07-0.96-0.22-2.29-0.56-3.84 c-0.87-4.01-2.42-6.82-3.41-8.59c-1.91-3.39-3.94-5.72-5-6.85c-0.56-0.6-2.57-2.7-5.7-4.9c-1.94-1.36-4.7-3.04-8.28-4.44 c-6.04-2.36-11.3-1.99-13.65-1.86c-2.36,0.13-7.25,0.63-12.55,2.98c-0.96,0.42-3.34,1.53-6.11,3.44 c-0.28,0.19-2.21,1.52-3.93,3.09C472.1,264.84,469.59,269.41,468.26,272.27z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_910_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_897_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    className: "st11",
    d: "M362.64,533.14c5.48,13,17.5,22.41,30.19,22.52s25.21-9.72,28.76-23.56 c-17.45,3.88-35.46,7.77-52.87,3.64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_909_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_777_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_801_",
    className: "st13",
    cx: 392.99,
    cy: 518.8,
    rx: 33.79,
    ry: 29.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_803_",
    className: "st14",
    cx: 391.08,
    cy: 518.8,
    rx: 13.53,
    ry: 12.13
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_907_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_804_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_805_",
    className: "st11",
    d: "M378.33,519.97c3.58,3.05,8,5.27,12.69,5.57s9.63-1.49,12.51-5.2 c0.7,2.71-0.17,5.67-1.86,7.89c-1.69,2.23-4.13,3.79-6.69,4.91c-1.39,0.61-2.84,1.1-4.35,1.31c-3.72,0.5-7.64-0.95-10.15-3.73 s-3.54-6.84-2.66-10.48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_896_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_970_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    className: "st5",
    d: "M374.67,573.76c-8.42,0-16.88-2.86-23-9.45c-5-5.38-7.72-12.66-7.72-20.59 c-16.43-17.27-21.63-39.23-22.99-55.48c-6.35-0.23-12.06-2.06-16.62-5.34c-10.32-7.43-11.8-19.85-13.24-31.87 c-1.53-12.82-3.44-28.76,7.05-41.78c4.44-5.51,10.57-9.78,17.84-12.43c-1.82-10.82-2.87-29.96,6.39-49.79 c1.37-2.93,2.92-5.79,4.64-8.55c-29.28-4.24-51.66-29.69-51.66-59.69c0-26.46,17.14-49.64,42.08-57.52 c-1.14-2.01-1.98-4.18-2.53-6.47c-1.79-7.49,0.23-13.78,1.72-17.07l-11.01-17.19l0.3-44.13l25.23,36.14l-2.53,20.08 c2.7,2.8,6.58,7.99,7.99,15.62c0.62,3.34,0.68,6.81,0.2,10.21c32.75,0.6,59.21,27.43,59.21,60.32 c0,12.78-4.04,25.13-11.47,35.38c4.18-0.46,8.24-0.84,12.28-1.16c19.91-1.54,40.16-1.53,60.26,0.02 c-6.91-10.02-10.67-21.99-10.67-34.24c0-32.89,26.46-59.72,59.21-60.32c-0.48-3.4-0.42-6.87,0.2-10.21 c1.41-7.64,5.29-12.82,8-15.62l-2.53-20.08l25.23-36.14l0.3,44.13l-11.01,17.19c1.49,3.28,3.51,9.58,1.72,17.07 c-0.55,2.29-1.4,4.46-2.53,6.47c24.95,7.88,42.08,31.06,42.08,57.52c0,21.45-11.24,41.03-29.56,51.89 c1.35,1.49,2.49,3.1,3.43,4.81c3.36,6.19,3.38,12.48,2.76,16.76l3.09,40.22c7.93,1.83,14.76,5.58,19.83,10.93 c9.95,10.48,10.21,23.4,10.46,35.88l0,0c0.23,11.39,0.52,25.58-9.5,38.26c-4.78,6.05-11.3,10.86-18.93,13.98 c0.76,17.92-3.26,33.19-11.96,45.39c-20.76,29.16-60.92,29.78-99.75,30.37c-14.42,0.22-28.06,0.43-40.35-0.68 C390.78,571.12,382.75,573.76,374.67,573.76z M325.62,483.2l0.15,2.4c1.01,15.81,5.73,38.26,22.47,55.38l0.74,0.76l-0.03,1.06 c-0.16,4.97,0.82,12.14,6.37,18.11c10.38,11.17,28.86,9.59,38.96,1.18l0.8-0.67l1.04,0.1c12.28,1.19,26.14,0.98,40.81,0.75 c37.59-0.58,76.47-1.18,95.76-28.28c8.31-11.67,11.99-26.48,10.95-44.02l-0.11-1.85l1.74-0.64c7.5-2.76,13.89-7.27,18.45-13.05 c8.91-11.28,8.65-23.91,8.42-35.06l0,0c-0.23-11.54-0.47-23.47-9.09-32.55c-5.99-6.32-13.65-8.85-19.02-9.86l-1.88-0.35 l-3.43-44.56l0.04-0.28c0.54-3.52,0.6-8.8-2.17-13.91c-1.18-2.17-2.79-4.13-4.81-5.84l-2.83-2.4l3.3-1.71 c18.43-9.57,29.87-28.4,29.87-49.13c0-25.35-17.14-47.4-41.67-53.64l-3.68-0.94l2.33-3.01c1.73-2.24,2.95-4.79,3.61-7.57 c1.72-7.22-1.04-13.23-1.93-14.9l-0.69-1.29l11.76-18.36l-0.19-26.98l-15.16,21.72l2.6,20.65l-0.92,0.87 c-2.21,2.08-6.11,6.65-7.43,13.81c-0.68,3.68-0.56,7.57,0.34,11.24l0.79,3.2l-3.67-0.12c-0.48-0.02-0.96-0.03-1.44-0.03 c-30.52,0-55.34,24.83-55.34,55.35c0,13,4.61,25.64,12.98,35.59l3.91,4.64l-6.04-0.55c-21.67-1.98-43.55-2.14-65.04-0.48 c-5.89,0.45-11.82,1.06-18.13,1.85l-6.62,0.83l4.45-4.97c9.1-10.16,14.11-23.27,14.11-36.91c0-30.52-24.83-55.35-55.34-55.35 c-0.48,0-0.96,0.02-1.44,0.03l-3.67,0.12l0.79-3.2c0.9-3.67,1.02-7.56,0.34-11.24c-1.32-7.16-5.22-11.73-7.43-13.81l-0.92-0.87 l2.6-20.65l-15.16-21.72l-0.19,26.98l11.76,18.36l-0.69,1.29c-0.89,1.67-3.65,7.67-1.93,14.9c0.66,2.78,1.88,5.33,3.61,7.57 l2.33,3.01l-3.69,0.94c-24.53,6.24-41.67,28.29-41.67,53.64c0,28.8,22.48,53.04,51.19,55.17l4.36,0.32l-2.5,3.59 c-2.48,3.56-4.67,7.35-6.5,11.27c-9.31,19.93-7.52,39.18-5.63,48.87l0.43,2.19l-2.13,0.67c-7.24,2.27-13.3,6.25-17.54,11.51 c-9.17,11.38-7.48,25.55-5.98,38.05c1.37,11.45,2.66,22.27,11.2,28.42c4.23,3.05,9.76,4.57,15.96,4.42L325.62,483.2z  M373.63,562.19c-3.5-0.48-6.83-1.8-9.64-3.83l2.53-4.28c2.62,1.24,5.39,2.34,8.23,3.26L373.63,562.19z M335.71,332.97 c-22.57,0-42.3-15.24-47.97-37.06c-0.63-2.65-1.09-5.35-1.38-8.09c-0.14-1.61-0.21-3.03-0.21-4.4c0-9.66,2.79-19.02,8.07-27.09 c2.59-3.74,5.02-6.35,5.13-6.46c1.16-1.24,3.56-3.8,7.17-6.48c4.33-3.16,9.09-5.58,14.15-7.19l1.25-0.37 c1.29-0.36,2.58-0.67,3.87-0.92l2.38-0.47l2.24,10.04l-2.01,0.77c-15.7,6.02-26.25,21.37-26.25,38.17 c0,15.9,9.34,29.98,22.94,36.69c-7.89-4.27-14.22-11.3-17.47-20.02l-0.02-0.07c-0.78-2.3-1.36-4.66-1.72-7.02 c-0.57-3.68-0.64-7.43-0.22-11.14c0.02-0.29,0.07-0.75,0.12-1.23l0.02-0.13c2.2-12.88,11.12-23.88,23.28-28.72l2.72-1.08 l16.45,73.74l-2.93,0.17c-0.17,0.01-0.33,0.02-0.5,0.03l-3.6,3.73c-1.17,1.21-2.3,2.46-3.36,3.72l-0.75,0.88H335.71z  M324.37,240.32c-0.36,0.09-0.72,0.19-1.08,0.29l-1.12,0.33c-4.54,1.44-8.81,3.61-12.7,6.45c-3.23,2.4-5.43,4.74-6.48,5.87 c-0.02,0.02-2.29,2.47-4.63,5.84c-4.71,7.2-7.22,15.62-7.22,24.31c0,1.22,0.06,2.51,0.18,3.92c0.27,2.48,0.7,4.98,1.26,7.37 c4.72,18.17,20.35,31.29,38.81,33.07c-19.72-5.21-34.23-23.37-34.23-44.36c0-18.14,10.95-34.75,27.45-42.01L324.37,240.32z  M312.31,298.38c4.66,12.45,16.53,20.9,29.77,21.29l-13.84-62.05c-9.15,4.65-15.75,13.47-17.51,23.64 c-0.05,0.39-0.08,0.75-0.1,1.06c-0.38,3.36-0.32,6.67,0.18,9.91C311.12,294.3,311.63,296.37,312.31,298.38z M526.8,328.77 l-1.03-0.44c-3.11-1.34-6.49-2.09-10.05-2.24l-11.44-0.48l6.52-2.66c-2.21,0.69-4.5,1.18-6.86,1.46l-0.39,0.05l-0.39-0.08 c-1.97-0.39-3.97-0.77-6-1.14l-2.55-0.47l16.08-72.08l2.72,1.08c12.16,4.84,21.08,15.84,23.28,28.72l0.02,0.13 c0.06,0.49,0.1,0.94,0.13,1.33c0.42,3.61,0.34,7.36-0.23,11.05c-0.36,2.36-0.94,4.72-1.72,7.02 c-3.24,8.7-9.38,15.68-17.14,19.96c13.82-6.9,22.59-20.93,22.59-36.57c0-16.81-10.55-32.15-26.25-38.17l-2.01-0.77l2.24-10.04 l2.38,0.47c1.29,0.25,2.58,0.56,3.85,0.92l1.25,0.37c5.08,1.62,9.83,4.03,14.15,7.18c3.63,2.69,6.03,5.26,7.19,6.49 c0.1,0.11,2.53,2.72,5.09,6.41c5.32,8.12,8.11,17.49,8.11,27.15c0,1.37-0.07,2.79-0.2,4.35c-0.3,2.79-0.76,5.5-1.38,8.09 c-3.72,14.34-13.54,26.14-26.95,32.44L526.8,328.77z M523.76,322.33c0.99,0.28,1.96,0.6,2.91,0.97 c11.56-5.77,20.01-16.15,23.25-28.65c0.55-2.34,0.98-4.84,1.25-7.37c0.12-1.36,0.18-2.64,0.18-3.87 c0-8.68-2.51-17.11-7.26-24.36c-2.3-3.32-4.57-5.76-4.6-5.79c-1.05-1.12-3.25-3.47-6.5-5.88c-3.87-2.82-8.15-4.99-12.7-6.44 l-1.12-0.33c-0.35-0.1-0.71-0.19-1.07-0.29l-0.24,1.08c16.5,7.26,27.45,23.87,27.45,42.01 C545.32,299.49,537.07,314.05,523.76,322.33z M500.61,318.8c1.05,0.2,2.1,0.4,3.13,0.6c12.07-1.57,22.18-9.61,26.45-21.06 c0.66-1.95,1.17-4.03,1.49-6.11c0.5-3.25,0.57-6.55,0.19-9.82c-0.03-0.4-0.07-0.77-0.11-1.16 c-1.76-10.17-8.36-18.99-17.51-23.64L500.61,318.8z M482.78,320.96l-2.78-1.67c-11.48-6.91-18.33-19.02-18.33-32.4 c0-11.92,5.45-22.89,14.97-30.11l0.03-0.02c0.52-0.38,0.9-0.65,1.02-0.73c2.64-1.81,5-3,6.52-3.67 c5.22-2.31,10.18-3.01,13.42-3.19l1.32-0.06c0.34-0.01,0.69-0.01,1.04,0l3.49,0.07L482.78,320.96z M479.63,260.76 c-8.25,6.27-12.98,15.79-12.98,26.13c0,10.51,4.87,20.11,13.18,26.29l16.99-58.95c-2.79,0.24-6.62,0.92-10.61,2.69 c-1.32,0.59-3.39,1.62-5.71,3.21C480.41,260.2,480.08,260.43,479.63,260.76z M359.71,320.96l-20.69-71.78l3.49-0.07 c0.35-0.01,0.69-0.01,1.04,0l1.32,0.06c3.25,0.18,8.21,0.88,13.42,3.19c1.52,0.67,3.88,1.85,6.51,3.66 c0.12,0.08,0.5,0.34,1.02,0.73c9.54,7.24,15,18.22,15,30.14c0,13.38-6.85,25.49-18.33,32.4L359.71,320.96z M345.67,254.23 l16.99,58.95c8.31-6.18,13.18-15.78,13.18-26.29c0-10.34-4.74-19.87-12.99-26.14c-0.43-0.32-0.77-0.55-0.87-0.62 c-2.31-1.59-4.38-2.62-5.7-3.21C352.28,255.16,348.45,254.47,345.67,254.23z M482.41,246.25l-2.22-4.47 c0.32-0.17,0.69-0.38,1.12-0.62c2.75-1.54,7.86-4.39,14.33-6.04c2.95-0.67,5.89-1.08,8.8-1.21l3.48-0.16l-2.63,9.14l-2.05-0.19 c-1.33-0.12-2.57-0.18-3.78-0.18C493.52,242.53,487.79,243.78,482.41,246.25z M360.08,246.25c-5.38-2.47-11.11-3.72-17.04-3.72 c-1.21,0-2.45,0.06-3.78,0.18l-2.05,0.19l-2.63-9.14l3.48,0.16c2.91,0.14,5.85,0.54,8.74,1.2c6.53,1.66,11.64,4.51,14.39,6.05 c0.43,0.24,0.8,0.45,1.12,0.62L360.08,246.25z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_894_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_806_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1392_",
    className: "st15",
    d: "M725.05,283.78c-1.37-5.83-7.05-10.35-13.03-10.38c-1.83-0.01-3.9,0.28-5.29-0.92 c-2.82-2.45-0.34-8.91-3.97-9.8c-1.13-0.28-2.28,0.29-3.41,0.57c-3.91,0.97-8.3-2.19-8.63-6.21c-0.29-3.59,1.44-8.63-1.95-9.82 c-1.96-0.68-3.96,0.9-6.03,1.11c-3.12,0.32-5.9-3.31-4.78-6.24c0.4-1.05,1.18-1.94,1.48-3.03c1.21-4.39-5.82-8.19-4.15-12.43 c1.37-3.48,7.75-4.01,7.38-7.73c-0.13-1.34-1.21-2.35-2.01-3.44c-3.17-4.34-1.26-11.42,3.66-13.59c1.55-0.68,3.38-0.9,4.94-0.24 c1.8,0.76,2.93,2.51,4.35,3.85s3.67,2.31,5.26,1.18c0.64-0.45,1.04-1.17,1.5-1.8c2.3-3.17,6.7-4.63,10.43-3.47 c3.74,1.16,6.53,4.87,6.62,8.78c0.09,3.89-1.76,8.89,1.55,10.94c1.44,0.9,3.28,0.68,4.97,0.89c5.37,0.69,9.29,6.89,7.6,12.04 c-1.35,4.1-5.42,8.67-2.56,11.91c1.23,1.39,3.27,1.67,4.81,2.69c3.66,2.44,3.23,8.13,0.95,11.9c-2.28,3.76-5.89,6.63-7.88,10.55 c-2,3.92-1.49,9.81,2.61,11.4c-1.41,0.74-2.83,1.48-4.24,2.22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_956_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_809_",
    className: "st3",
    d: "M719.7,263.81c-5.71-16.66-15.1-32.24-27.17-45.06l0.91-0.86 c12.19,12.95,21.68,28.69,27.44,45.51L719.7,263.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_892_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_808_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1386_",
    className: "st16",
    d: "M726.83,244.83c-1.37-5.83-7.05-10.35-13.03-10.38c-1.83-0.01-3.9,0.28-5.29-0.92 c-2.82-2.45-0.34-8.91-3.97-9.8c-1.13-0.28-2.28,0.29-3.41,0.57c-3.91,0.97-8.3-2.19-8.63-6.21c-0.29-3.59,1.44-8.63-1.95-9.82 c-1.96-0.68-3.96,0.9-6.03,1.11c-3.12,0.32-5.9-3.31-4.78-6.24c0.4-1.05,1.18-1.94,1.48-3.03c1.21-4.39-5.82-8.19-4.15-12.43 c1.37-3.48,7.75-4.01,7.38-7.73c-0.13-1.34-1.21-2.35-2.01-3.44c-3.17-4.34-1.26-11.42,3.66-13.59c1.55-0.68,3.38-0.9,4.94-0.24 c1.8,0.76,2.93,2.51,4.35,3.85s3.67,2.31,5.26,1.18c0.64-0.45,1.04-1.17,1.5-1.8c2.3-3.17,6.7-4.63,10.43-3.47 c3.74,1.16,6.53,4.87,6.62,8.78c0.09,3.89-1.76,8.89,1.55,10.94c1.44,0.9,3.28,0.68,4.97,0.89c5.37,0.69,9.29,6.89,7.6,12.04 c-1.35,4.1-5.42,8.67-2.56,11.91c1.23,1.39,3.27,1.67,4.81,2.69c3.66,2.44,3.23,8.13,0.95,11.9s-5.89,6.63-7.88,10.55 c-2,3.92-1.49,9.81,2.61,11.4c-1.41,0.74-2.83,1.48-4.24,2.22"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_955_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    className: "st17",
    d: "M721.49,224.86c-5.71-16.66-15.1-32.24-27.17-45.06l0.91-0.86 c12.19,12.95,21.68,28.69,27.44,45.51L721.49,224.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_882_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_890_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_812_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1380_",
    className: "st18",
    d: "M743.13,312.22c-0.81-5.93-6.04-10.97-12-11.56c-1.82-0.18-3.91-0.09-5.18-1.41 c-2.58-2.71,0.5-8.91-3.03-10.13c-1.1-0.38-2.29,0.08-3.45,0.25c-3.98,0.59-8.06-2.97-8-6.99c0.05-3.6,2.25-8.46-1.02-9.96 c-1.89-0.87-4.03,0.52-6.1,0.53c-3.14,0.02-5.56-3.86-4.17-6.67c0.5-1.01,1.36-1.82,1.76-2.88c1.62-4.26-5.02-8.71-2.96-12.77 c1.69-3.33,8.09-3.26,8.07-7c-0.01-1.35-0.99-2.45-1.68-3.61c-2.75-4.62-0.18-11.49,4.93-13.18c1.61-0.53,3.45-0.58,4.94,0.23 c1.72,0.93,2.68,2.78,3.97,4.25c1.28,1.47,3.44,2.65,5.13,1.67c0.68-0.39,1.15-1.06,1.67-1.65c2.59-2.94,7.11-3.98,10.72-2.47 s6.04,5.46,5.76,9.37c-0.28,3.88-2.59,8.69,0.51,11.04c1.35,1.03,3.2,0.98,4.86,1.36c5.29,1.19,8.6,7.73,6.43,12.7 c-1.73,3.96-6.21,8.12-3.67,11.61c1.09,1.49,3.1,1.97,4.53,3.14c3.41,2.78,2.45,8.4-0.17,11.93c-2.63,3.53-6.48,6.05-8.84,9.76 s-2.41,9.63,1.52,11.59c-1.48,0.6-2.96,1.21-4.43,1.81"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_815_",
    className: "st17",
    d: "M714.42,244.65c10.8,14.15,18.47,30.1,22.77,47.37c0.43,1.71,6.55,0.72,6.2-0.66 c-4.36-17.47-12.13-33.63-23.06-47.94C719.3,242.06,713.47,243.41,714.42,244.65L714.42,244.65z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_879_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1372_",
    className: "st15",
    d: "M581.88,675.66c5.25-2.29,8.54-8.4,7.54-14.05c-0.3-1.73-0.93-3.63-0.04-5.13 c1.83-3.07,8.33-1.85,8.54-5.42c0.07-1.11-0.66-2.09-1.12-3.11c-1.58-3.52,0.65-8.19,4.37-9.18c3.33-0.89,8.37-0.12,8.91-3.52 c0.31-1.96-1.52-3.57-2.07-5.48c-0.83-2.88,2.11-6.12,5.06-5.57c1.06,0.2,2.03,0.78,3.1,0.88c4.34,0.39,6.72-6.88,10.99-6.03 c3.51,0.69,5.1,6.61,8.54,5.63c1.24-0.35,2-1.55,2.89-2.48c3.55-3.73,10.54-3.14,13.42,1.12c0.91,1.34,1.43,3.03,1.07,4.61 c-0.41,1.82-1.86,3.19-2.88,4.75s-1.55,3.85-0.21,5.16c0.54,0.53,1.28,0.78,1.96,1.11c3.38,1.62,5.5,5.51,5.05,9.23 c-0.46,3.72-3.47,6.98-7.13,7.73c-3.65,0.75-8.67-0.14-10.04,3.33c-0.6,1.51-0.07,3.2,0.01,4.83 c0.27,5.18-4.9,9.92-10.03,9.21c-4.09-0.57-9.09-3.62-11.64-0.37c-1.09,1.39-1.01,3.36-1.71,4.99 c-1.67,3.86-7.1,4.43-11.04,2.93c-3.93-1.5-7.25-4.41-11.28-5.62s-9.49,0.27-10.28,4.41c-0.94-1.2-1.88-2.41-2.82-3.61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_954_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_818_",
    className: "st3",
    d: "M600.36,668.28l-0.61-1.09c14.7-8.22,27.76-19.73,37.76-33.28l1,0.74 C628.41,648.35,615.22,659.97,600.36,668.28z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_817_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1365_",
    className: "st16",
    d: "M618.85,670.68c5.25-2.29,8.54-8.4,7.54-14.05c-0.3-1.73-0.93-3.63-0.04-5.13 c1.83-3.07,8.33-1.85,8.54-5.42c0.07-1.11-0.66-2.09-1.12-3.11c-1.58-3.52,0.65-8.19,4.37-9.18c3.33-0.89,8.37-0.12,8.91-3.52 c0.31-1.96-1.52-3.57-2.07-5.48c-0.83-2.88,2.11-6.12,5.06-5.57c1.06,0.2,2.03,0.78,3.1,0.88c4.34,0.39,6.72-6.88,10.99-6.03 c3.51,0.69,5.1,6.61,8.54,5.63c1.24-0.35,2-1.55,2.89-2.48c3.55-3.73,10.54-3.14,13.42,1.12c0.91,1.34,1.43,3.03,1.07,4.61 c-0.41,1.82-1.86,3.19-2.88,4.75s-1.55,3.85-0.21,5.16c0.54,0.53,1.28,0.78,1.96,1.11c3.38,1.62,5.5,5.51,5.05,9.23 c-0.46,3.72-3.47,6.98-7.13,7.73c-3.65,0.75-8.67-0.14-10.04,3.33c-0.6,1.51-0.07,3.2,0.01,4.83 c0.27,5.18-4.9,9.92-10.03,9.21c-4.09-0.57-9.09-3.62-11.65-0.37c-1.09,1.39-1.01,3.36-1.71,4.99 c-1.67,3.86-7.1,4.43-11.04,2.93s-7.25-4.41-11.28-5.62s-9.49,0.27-10.28,4.41c-0.94-1.2-1.88-2.41-2.82-3.61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_877_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_953_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_820_",
    className: "st17",
    d: "M637.33,663.3l-0.61-1.09c14.7-8.22,27.76-19.73,37.76-33.28l1,0.74 C665.38,643.37,652.18,655,637.33,663.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_873_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_875_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_819_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_821_",
    className: "st18",
    d: "M558.2,697.54c5.45-1.78,9.29-7.56,8.83-13.27c-0.14-1.75-0.59-3.7,0.45-5.11 c2.11-2.89,8.47-1.05,9.02-4.59c0.17-1.1-0.46-2.15-0.82-3.2c-1.24-3.65,1.42-8.09,5.22-8.73c3.4-0.57,8.35,0.67,9.2-2.66 c0.49-1.92-1.18-3.7-1.55-5.65c-0.56-2.95,2.68-5.89,5.56-5.06c1.04,0.3,1.95,0.97,3.01,1.17c4.29,0.79,7.34-6.22,11.51-4.97 c3.43,1.02,4.45,7.06,7.97,6.4c1.27-0.24,2.14-1.35,3.11-2.19c3.88-3.38,10.79-2.14,13.25,2.38c0.78,1.42,1.13,3.15,0.63,4.69 c-0.58,1.77-2.15,3-3.32,4.46s-1.9,3.69-0.7,5.11c0.49,0.57,1.2,0.9,1.84,1.29c3.21,1.93,4.96,6.01,4.15,9.67 s-4.11,6.62-7.83,7.02c-3.7,0.4-8.62-0.95-10.31,2.37c-0.74,1.45-0.38,3.18-0.44,4.81c-0.22,5.18-5.81,9.42-10.86,8.23 c-4.02-0.95-8.71-4.46-11.56-1.47c-1.22,1.28-1.32,3.25-2.18,4.8c-2.03,3.69-7.49,3.74-11.26,1.88s-6.8-5.07-10.7-6.66 c-3.9-1.59-9.48-0.62-10.65,3.42c-0.82-1.29-1.64-2.58-2.47-3.86"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_952_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_823_",
    className: "st17",
    d: "M577.29,691.94l-0.5-1.14c15.41-6.8,29.5-17.02,40.73-29.57l0.93,0.83 C607.1,674.74,592.86,685.07,577.29,691.94z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_871_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_810_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1350_",
    className: "st15",
    d: "M636.57,618.82c4.72-3.25,6.77-9.89,4.7-15.23c-0.63-1.64-1.61-3.38-1.02-5.03 c1.2-3.37,7.82-3.41,7.35-6.96c-0.15-1.11-1.05-1.93-1.7-2.84c-2.22-3.15-0.94-8.16,2.52-9.85c3.09-1.51,8.19-1.72,8.07-5.16 c-0.07-1.99-2.18-3.22-3.09-4.98c-1.37-2.67,0.9-6.41,3.9-6.43c1.08-0.01,2.14,0.38,3.22,0.27c4.33-0.45,5.27-8.04,9.63-8.03 c3.57,0.01,6.27,5.51,9.46,3.88c1.15-0.59,1.67-1.9,2.36-2.99c2.76-4.34,9.74-5.11,13.38-1.47c1.15,1.15,1.98,2.7,1.94,4.32 c-0.05,1.87-1.21,3.49-1.92,5.22c-0.7,1.73-0.78,4.07,0.78,5.1c0.63,0.41,1.4,0.52,2.13,0.71c3.62,0.94,6.46,4.35,6.73,8.09 s-2.06,7.51-5.52,8.96c-3.44,1.44-8.54,1.53-9.21,5.19c-0.29,1.6,0.54,3.16,0.94,4.74c1.26,5.03-2.9,10.68-8.08,10.97 c-4.12,0.23-9.62-1.81-11.5,1.87c-0.81,1.58-0.35,3.49-0.72,5.22c-0.9,4.11-6.12,5.72-10.27,5s-7.96-2.93-12.15-3.35 s-9.26,2.09-9.25,6.3c-1.15-1-2.31-2-3.46-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_950_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_822_",
    className: "st3",
    d: "M653.29,608.02l-0.81-0.95c12.85-10.89,23.45-24.69,30.67-39.91l1.13,0.53 C676.99,583.07,666.27,597.02,653.29,608.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_869_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_813_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1344_",
    className: "st16",
    d: "M671.89,606.83c4.72-3.25,6.77-9.89,4.7-15.23c-0.63-1.64-1.61-3.38-1.02-5.03 c1.2-3.37,7.82-3.41,7.35-6.96c-0.15-1.11-1.05-1.93-1.7-2.84c-2.22-3.15-0.94-8.16,2.52-9.85c3.09-1.51,8.19-1.72,8.07-5.16 c-0.07-1.99-2.18-3.22-3.09-4.98c-1.37-2.67,0.9-6.41,3.9-6.44c1.08-0.01,2.14,0.38,3.22,0.27c4.33-0.45,5.27-8.04,9.63-8.03 c3.57,0.01,6.27,5.51,9.46,3.88c1.15-0.59,1.67-1.9,2.36-2.99c2.76-4.34,9.74-5.11,13.38-1.47c1.15,1.15,1.98,2.7,1.94,4.32 c-0.05,1.87-1.21,3.49-1.92,5.22s-0.78,4.07,0.78,5.1c0.63,0.41,1.4,0.52,2.13,0.71c3.62,0.94,6.46,4.35,6.73,8.09 s-2.06,7.51-5.52,8.96c-3.44,1.44-8.54,1.53-9.21,5.19c-0.29,1.6,0.54,3.16,0.94,4.74c1.26,5.03-2.9,10.68-8.08,10.97 c-4.12,0.23-9.62-1.81-11.5,1.87c-0.81,1.58-0.35,3.49-0.72,5.22c-0.9,4.11-6.12,5.72-10.27,5s-7.96-2.93-12.15-3.35 s-9.26,2.09-9.25,6.3c-1.15-1-2.31-2-3.46-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_868_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_949_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_825_",
    className: "st17",
    d: "M688.61,596.04l-0.81-0.95c12.85-10.89,23.45-24.69,30.67-39.91l1.13,0.53 C712.31,571.09,701.59,585.04,688.61,596.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_867_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_824_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    className: "st18",
    d: "M617.53,644.84c5-2.79,7.67-9.2,6.12-14.72c-0.47-1.69-1.29-3.52-0.54-5.11 c1.52-3.24,8.11-2.66,7.97-6.23c-0.04-1.11-0.87-2.02-1.42-2.99c-1.92-3.34-0.16-8.21,3.44-9.57c3.22-1.21,8.32-0.94,8.52-4.38 c0.11-1.98-1.87-3.41-2.6-5.25c-1.11-2.79,1.5-6.3,4.49-6.04c1.07,0.09,2.1,0.58,3.18,0.57c4.36-0.04,6.01-7.51,10.34-7.09 c3.56,0.34,5.73,6.07,9.05,4.76c1.2-0.48,1.84-1.74,2.63-2.75c3.16-4.06,10.18-4.17,13.46-0.21c1.03,1.25,1.72,2.87,1.52,4.48 c-0.23,1.85-1.54,3.36-2.4,5.01c-0.86,1.66-1.16,3.98,0.3,5.15c0.59,0.47,1.35,0.65,2.05,0.91c3.52,1.28,6.02,4.94,5.93,8.69 c-0.09,3.74-2.76,7.29-6.34,8.4c-3.56,1.11-8.64,0.72-9.66,4.3c-0.44,1.56,0.24,3.2,0.49,4.8c0.78,5.12-3.89,10.36-9.07,10.16 c-4.13-0.16-9.4-2.71-11.62,0.78c-0.95,1.49-0.67,3.45-1.21,5.13c-1.28,4.01-6.63,5.11-10.69,4.01 c-4.06-1.11-7.65-3.67-11.78-4.48s-9.42,1.21-9.8,5.4c-1.05-1.11-2.11-2.21-3.16-3.32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_948_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_827_",
    className: "st17",
    d: "M635.19,635.67l-0.71-1.02c13.82-9.63,25.68-22.37,34.29-36.84l1.07,0.64 C661.14,613.07,649.15,625.94,635.19,635.67z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1332_",
    className: "st15",
    d: "M710.27,548.78c0.24-5.73,4.76-10.99,10.38-12.1c1.72-0.34,3.72-0.44,4.8-1.81 c2.21-2.81-1.28-8.44,1.97-9.92c1.02-0.46,2.19-0.14,3.31-0.08c3.85,0.2,7.41-3.55,6.99-7.39c-0.37-3.42-2.91-7.85,0.07-9.58 c1.72-1,3.88,0.13,5.86-0.04c2.99-0.26,4.95-4.18,3.37-6.73c-0.57-0.92-1.46-1.61-1.94-2.58c-1.93-3.91,4-8.75,1.67-12.43 c-1.91-3.02-8-2.37-8.32-5.93c-0.12-1.28,0.72-2.43,1.27-3.59c2.2-4.65-0.87-10.96-5.88-12.11c-1.58-0.36-3.34-0.24-4.69,0.66 c-1.55,1.04-2.31,2.89-3.39,4.4c-1.09,1.52-3.03,2.83-4.73,2.06c-0.69-0.31-1.19-0.91-1.74-1.43 c-2.73-2.56-7.13-3.15-10.43-1.38s-5.26,5.75-4.64,9.44c0.62,3.67,3.25,8.04,0.51,10.56c-1.2,1.1-2.96,1.22-4.51,1.73 c-4.93,1.61-7.49,8.14-4.98,12.68c2,3.61,6.65,7.18,4.54,10.73c-0.9,1.52-2.77,2.16-4.03,3.4c-3,2.95-1.58,8.22,1.24,11.35 s6.72,5.18,9.31,8.5c2.58,3.32,3.17,8.95-0.4,11.18c1.46,0.44,2.92,0.88,4.39,1.33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_947_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_829_",
    className: "st3",
    d: "M711.73,529.05l-1.24-0.18c2.39-16.85,8.48-33.35,17.61-47.71l1.05,0.67 C720.12,496.05,714.09,512.38,711.73,529.05z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_863_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1326_",
    className: "st16",
    d: "M701.58,512.5c0.24-5.73,4.76-10.99,10.38-12.1c1.72-0.34,3.72-0.44,4.8-1.81 c2.21-2.81-1.28-8.44,1.97-9.92c1.02-0.46,2.19-0.14,3.31-0.08c3.85,0.2,7.41-3.55,6.99-7.39c-0.37-3.42-2.91-7.85,0.07-9.58 c1.72-1,3.88,0.13,5.86-0.04c2.99-0.26,4.95-4.18,3.37-6.73c-0.57-0.92-1.46-1.61-1.94-2.58c-1.93-3.91,4-8.75,1.67-12.43 c-1.91-3.02-8-2.37-8.32-5.93c-0.12-1.28,0.72-2.43,1.27-3.59c2.2-4.65-0.87-10.96-5.88-12.11c-1.58-0.36-3.34-0.24-4.69,0.66 c-1.55,1.04-2.31,2.89-3.39,4.4c-1.09,1.52-3.03,2.83-4.73,2.06c-0.69-0.31-1.19-0.91-1.74-1.43 c-2.73-2.56-7.13-3.15-10.43-1.38s-5.26,5.75-4.64,9.44c0.62,3.67,3.25,8.04,0.51,10.56c-1.2,1.1-2.96,1.22-4.51,1.73 c-4.93,1.61-7.49,8.14-4.98,12.68c2,3.61,6.65,7.18,4.54,10.73c-0.9,1.52-2.77,2.16-4.03,3.4c-3,2.95-1.58,8.22,1.24,11.35 s6.72,5.18,9.31,8.5s3.17,8.95-0.4,11.18c1.46,0.44,2.92,0.88,4.39,1.33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_946_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_831_",
    className: "st17",
    d: "M703.04,492.78l-1.24-0.18c2.39-16.85,8.48-33.35,17.61-47.71l1.05,0.67 C711.44,459.78,705.41,476.1,703.04,492.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_861_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1320_",
    className: "st18",
    d: "M698.39,578.76c-0.3-5.72,3.7-11.39,9.2-13.02c1.68-0.5,3.66-0.78,4.61-2.26 c1.93-3.01-2.07-8.28,1.03-10.06c0.97-0.56,2.17-0.34,3.28-0.39c3.85-0.16,7.04-4.24,6.26-8.01c-0.69-3.37-3.64-7.54-0.83-9.54 c1.62-1.15,3.88-0.24,5.83-0.6c2.95-0.54,4.53-4.62,2.72-7.01c-0.65-0.86-1.61-1.47-2.17-2.39c-2.29-3.71,3.15-9.08,0.49-12.53 c-2.19-2.83-8.19-1.61-8.85-5.12c-0.24-1.27,0.49-2.48,0.93-3.69c1.75-4.84-1.9-10.83-7-11.5c-1.61-0.21-3.34,0.08-4.6,1.1 c-1.45,1.18-2.02,3.09-2.96,4.7s-2.75,3.1-4.52,2.49c-0.71-0.25-1.27-0.79-1.86-1.26c-2.96-2.3-7.39-2.46-10.51-0.39 s-4.69,6.22-3.73,9.84c0.96,3.6,3.99,7.7,1.51,10.47c-1.09,1.21-2.83,1.5-4.32,2.15c-4.75,2.07-6.69,8.81-3.76,13.09 c2.33,3.41,7.3,6.52,5.54,10.25c-0.76,1.6-2.56,2.41-3.7,3.76c-2.71,3.22-0.79,8.34,2.31,11.18c3.1,2.85,7.18,4.52,10.07,7.58 c2.89,3.07,4,8.61,0.65,11.17c1.5,0.3,2.99,0.61,4.49,0.91"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_860_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_945_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_833_",
    className: "st17",
    d: "M697.98,558.98l-1.24-0.06c0.79-17,5.3-34,13.04-49.16l1.11,0.57 C703.23,525.34,698.77,542.16,697.98,558.98z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_859_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1314_",
    className: "st15",
    d: "M731.32,449.18c-0.47-5.97,3.57-12,9.27-13.85c1.74-0.57,3.81-0.92,4.76-2.48 c1.94-3.19-2.38-8.6,0.81-10.54c1-0.61,2.26-0.41,3.42-0.49c4.02-0.27,7.24-4.61,6.33-8.54c-0.81-3.51-4-7.78-1.12-9.95 c1.66-1.25,4.04-0.35,6.08-0.78c3.07-0.65,4.61-4.95,2.66-7.4c-0.7-0.88-1.72-1.49-2.33-2.44c-2.49-3.82,3.06-9.57,0.18-13.1 c-2.36-2.9-8.6-1.47-9.38-5.12c-0.28-1.32,0.44-2.61,0.87-3.88c1.7-5.1-2.27-11.27-7.61-11.83c-1.69-0.18-3.49,0.17-4.78,1.27 c-1.48,1.27-2.03,3.28-2.97,4.99c-0.94,1.71-2.79,3.32-4.65,2.72c-0.75-0.24-1.35-0.8-1.98-1.26 c-3.15-2.32-7.79-2.38-10.99-0.13c-3.21,2.24-4.74,6.62-3.64,10.38c1.1,3.73,4.38,7.94,1.85,10.9c-1.1,1.29-2.92,1.64-4.46,2.36 c-4.91,2.29-6.76,9.38-3.59,13.78c2.53,3.5,7.8,6.62,6.05,10.57c-0.75,1.69-2.61,2.58-3.76,4.03 c-2.75,3.44-0.61,8.73,2.71,11.62s7.62,4.53,10.72,7.66c3.1,3.13,4.4,8.89,0.98,11.65c1.57,0.28,3.14,0.55,4.72,0.83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_858_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_943_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_835_",
    className: "st3",
    d: "M730.34,428.53l-1.25-0.03c0.38-17.78,4.64-35.65,12.32-51.69l1.13,0.54 C734.94,393.23,730.72,410.93,730.34,428.53z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_857_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1308_",
    className: "st16",
    d: "M717.78,412.62c-0.47-5.97,3.57-12,9.27-13.85c1.74-0.57,3.81-0.92,4.76-2.48 c1.94-3.19-2.38-8.6,0.81-10.54c1-0.61,2.26-0.41,3.42-0.49c4.02-0.27,7.24-4.61,6.33-8.54c-0.81-3.51-4-7.78-1.12-9.95 c1.66-1.25,4.04-0.35,6.08-0.78c3.07-0.65,4.61-4.95,2.66-7.4c-0.7-0.88-1.72-1.49-2.33-2.44c-2.49-3.82,3.06-9.57,0.18-13.1 c-2.36-2.9-8.6-1.47-9.38-5.12c-0.28-1.32,0.44-2.61,0.87-3.88c1.7-5.1-2.27-11.27-7.61-11.83c-1.69-0.18-3.49,0.17-4.78,1.27 c-1.48,1.27-2.03,3.28-2.97,4.99s-2.79,3.32-4.65,2.72c-0.75-0.24-1.35-0.8-1.98-1.26c-3.15-2.32-7.79-2.38-10.99-0.13 c-3.21,2.24-4.74,6.62-3.64,10.38c1.1,3.73,4.38,7.94,1.85,10.9c-1.1,1.29-2.92,1.64-4.46,2.36c-4.91,2.29-6.76,9.38-3.59,13.78 c2.53,3.5,7.8,6.62,6.05,10.57c-0.75,1.69-2.61,2.58-3.76,4.03c-2.75,3.44-0.61,8.73,2.71,11.62s7.62,4.53,10.72,7.66 c3.1,3.13,4.4,8.89,0.98,11.65c1.57,0.28,3.14,0.55,4.72,0.83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_856_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_942_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_837_",
    className: "st17",
    d: "M716.81,391.97l-1.25-0.03c0.38-17.78,4.64-35.65,12.32-51.69l1.13,0.54 C721.41,356.67,717.19,374.36,716.81,391.97z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_855_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_836_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1302_",
    className: "st18",
    d: "M722.73,481.77c-1.03-5.9,2.42-12.28,7.92-14.66c1.68-0.73,3.7-1.27,4.5-2.92 c1.63-3.36-3.18-8.33-0.19-10.57c0.93-0.7,2.21-0.62,3.36-0.81c3.98-0.65,6.78-5.27,5.5-9.1c-1.14-3.41-4.71-7.37-2.05-9.8 c1.53-1.4,3.99-0.73,5.98-1.35c2.99-0.93,4.13-5.36,1.95-7.62c-0.78-0.81-1.85-1.32-2.55-2.2c-2.83-3.57,2.14-9.82-1.06-13.06 c-2.62-2.66-8.7-0.65-9.82-4.21c-0.4-1.28,0.2-2.64,0.5-3.95c1.21-5.24-3.32-11.01-8.7-11.06c-1.7-0.02-3.46,0.5-4.64,1.72 c-1.35,1.41-1.71,3.46-2.49,5.25c-0.77,1.79-2.47,3.56-4.38,3.15c-0.77-0.17-1.41-0.67-2.09-1.07 c-3.36-2.01-7.98-1.63-10.96,0.9c-2.98,2.54-4.09,7.04-2.64,10.67c1.44,3.61,5.11,7.49,2.87,10.67 c-0.98,1.39-2.75,1.91-4.22,2.77c-4.67,2.74-5.84,9.98-2.27,14.05c2.85,3.25,8.39,5.85,7.02,9.95 c-0.59,1.76-2.35,2.82-3.37,4.37c-2.41,3.68,0.22,8.75,3.79,11.32s8.02,3.79,11.39,6.62c3.38,2.82,5.22,8.44,2.07,11.51 c1.59,0.13,3.18,0.25,4.77,0.38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_941_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_839_",
    className: "st17",
    d: "M718.57,461.39c-1.29-17.74,1.26-35.93,7.4-52.63l1.17,0.43 c-6.07,16.53-8.61,34.54-7.32,52.1L718.57,461.39z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_838_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1296_",
    className: "st16",
    d: "M724.89,343.89c0.47-5.97-3.57-12-9.27-13.85c-1.74-0.57-3.81-0.92-4.76-2.48 c-1.94-3.19,2.38-8.6-0.81-10.54c-1-0.61-2.26-0.41-3.42-0.49c-4.02-0.27-7.24-4.61-6.33-8.54c0.81-3.51,4-7.78,1.12-9.95 c-1.66-1.25-4.04-0.35-6.08-0.78c-3.07-0.65-4.61-4.95-2.66-7.4c0.7-0.88,1.72-1.49,2.33-2.44c2.49-3.82-3.06-9.57-0.18-13.1 c2.36-2.9,8.6-1.47,9.38-5.12c0.28-1.32-0.44-2.61-0.87-3.88c-1.7-5.1,2.27-11.27,7.61-11.83c1.69-0.18,3.49,0.17,4.78,1.27 c1.48,1.27,2.03,3.28,2.97,4.99c0.94,1.71,2.79,3.32,4.65,2.72c0.75-0.24,1.35-0.8,1.98-1.26c3.15-2.32,7.79-2.38,10.99-0.13 c3.21,2.24,4.74,6.62,3.64,10.38c-1.1,3.73-4.38,7.94-1.85,10.9c1.1,1.29,2.92,1.64,4.46,2.36c4.91,2.29,6.76,9.38,3.59,13.78 c-2.53,3.5-7.8,6.62-6.05,10.57c0.75,1.69,2.61,2.58,3.76,4.03c2.75,3.44,0.61,8.73-2.71,11.62s-7.62,4.53-10.72,7.66 c-3.1,3.13-4.4,8.89-0.98,11.65c-1.57,0.28-3.14,0.55-4.72,0.83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_841_",
    className: "st16",
    d: "M714.22,271.79c7.67,16.02,11.88,33.68,12.26,51.44"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1290_",
    className: "st16",
    d: "M738.42,307.33c0.47-5.97-3.57-12-9.27-13.85c-1.74-0.57-3.81-0.92-4.76-2.48 c-1.94-3.19,2.38-8.6-0.81-10.54c-1-0.61-2.26-0.41-3.42-0.49c-4.02-0.27-7.24-4.61-6.33-8.54c0.81-3.51,4-7.78,1.12-9.95 c-1.66-1.25-4.04-0.35-6.08-0.78c-3.07-0.65-4.61-4.95-2.66-7.4c0.7-0.88,1.72-1.49,2.33-2.44c2.49-3.82-3.06-9.57-0.18-13.1 c2.36-2.9,8.6-1.47,9.38-5.12c0.28-1.32-0.44-2.61-0.87-3.88c-1.7-5.1,2.27-11.27,7.61-11.83c1.69-0.18,3.49,0.17,4.78,1.27 c1.48,1.27,2.03,3.28,2.97,4.99s2.79,3.32,4.65,2.72c0.75-0.24,1.35-0.8,1.98-1.26c3.15-2.32,7.79-2.38,10.99-0.13 c3.21,2.24,4.74,6.62,3.64,10.38c-1.1,3.73-4.38,7.94-1.85,10.9c1.1,1.29,2.92,1.64,4.46,2.36c4.91,2.29,6.76,9.38,3.59,13.78 c-2.53,3.5-7.8,6.62-6.05,10.57c0.75,1.69,2.61,2.58,3.76,4.03c2.75,3.44,0.61,8.73-2.71,11.62s-7.62,4.53-10.72,7.66 s-4.4,8.89-0.98,11.65c-1.57,0.28-3.14,0.55-4.72,0.83"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_848_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_940_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_844_",
    className: "st17",
    d: "M739.4,286.68c-0.38-17.6-4.6-35.3-12.2-51.18l1.13-0.54 c7.68,16.04,11.94,33.91,12.32,51.69L739.4,286.68z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_847_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1284_",
    className: "st18",
    d: "M733.48,376.48c1.03-5.9-2.42-12.28-7.92-14.66c-1.68-0.73-3.7-1.27-4.5-2.92 c-1.63-3.36,3.18-8.33,0.19-10.57c-0.93-0.7-2.21-0.62-3.36-0.81c-3.98-0.65-6.78-5.27-5.5-9.1c1.14-3.41,4.71-7.37,2.05-9.8 c-1.53-1.4-3.99-0.73-5.98-1.35c-2.99-0.93-4.13-5.36-1.95-7.62c0.78-0.81,1.85-1.32,2.55-2.2c2.83-3.57-2.14-9.82,1.06-13.06 c2.62-2.66,8.7-0.65,9.82-4.21c0.4-1.28-0.2-2.64-0.5-3.95c-1.21-5.24,3.32-11.01,8.7-11.06c1.7-0.02,3.46,0.5,4.64,1.72 c1.35,1.41,1.71,3.46,2.49,5.25c0.77,1.79,2.47,3.56,4.38,3.15c0.77-0.17,1.41-0.67,2.09-1.07c3.36-2.01,7.98-1.63,10.96,0.9 c2.98,2.54,4.09,7.04,2.64,10.67c-1.44,3.61-5.11,7.49-2.87,10.67c0.98,1.39,2.75,1.91,4.22,2.77 c4.67,2.74,5.84,9.98,2.27,14.05c-2.85,3.25-8.39,5.85-7.02,9.95c0.59,1.76,2.35,2.82,3.37,4.37c2.41,3.68-0.22,8.75-3.79,11.32 s-8.02,3.79-11.39,6.62c-3.38,2.82-5.22,8.44-2.07,11.51c-1.59,0.13-3.18,0.25-4.77,0.38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_939_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_846_",
    className: "st17",
    d: "M737.64,356.11l-1.24-0.09c1.28-17.56-1.25-35.58-7.32-52.1l1.17-0.43 C736.38,320.17,738.93,338.37,737.64,356.11z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_906_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_963_",
    className: "st19",
    d: "M116.21,449.42c-4.01-13.75-6.34-27.98-6.92-42.29c8.02,7.59,16.38,14.82,25.04,21.66 c2.17,1.71,4.93,3.5,7.51,2.48c1.26-0.5,2.18-1.58,3.04-2.63c4.11-5,8.23-9.99,12.34-14.99c4.09,6.97,2.1,16.21,5.92,23.33 c1.46,2.73,3.73,5.04,4.73,7.97c1.1,3.23,0.51,6.76-0.15,10.11c-3.11,15.91-7.37,31.6-12.74,46.9c-0.43,1.24-0.85,2.72-0.07,3.77 c1.19,1.62,3.84,0.69,5.65,1.55c1.93,0.91,2.32,3.44,2.45,5.57c0.49,7.93,0.98,15.86,1.47,23.79c2.61,1.27,5.37-1.29,7.15-3.58 c4.24-5.47,8.48-10.94,12.72-16.41c0.6,14.09-4.63,28.34-14.22,38.69c-14.16-7.31-29.35-15.7-35.64-30.34 c-3.35-7.79-3.73-16.51-3.45-24.98c0.27-8.04,1.09-16.14-0.05-24.11c-1.25-8.7-4.87-17.05-10.38-23.91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_964_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_967_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1275_",
    className: "st19",
    d: "M165.36,195.46c3.86,16.55,9.87,51.01,0.4,85.53c-5.53,20.14-16.42,39.35-20.86,47.26 c-5.78,10.31-11.19,18.27-15.21,23.8c-0.9-5.25-1.98-12.46-2.77-21.13c-2.5-27.52-0.18-48.52,0.32-52.85 c1.25-10.94,2.79-24.3,8.16-39.06C143.78,215.96,156.77,202.53,165.36,195.46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_968_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1273_",
    className: "st20",
    d: "M165.36,195.46c-11.87,52.22-23.75,104.44-35.62,156.66 c11.26-13.45,18.73-27.01,23.42-36.86c3.68-7.75,8.7-18.45,12.6-34.28c5.37-21.81,5.3-39.87,5.21-45.23 C170.67,218.71,167.9,204.89,165.36,195.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_969_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_989_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1270_",
    className: "st19",
    d: "M125.36,207.57c7.28,9.1,20.6,28.68,19.93,53.18c-0.39,14.3-5.84,29.71-8.04,36.04 c-2.87,8.25-5.94,14.92-8.31,19.64c-2.02-2.99-4.64-7.14-7.34-12.3c-8.56-16.36-11.26-30.18-11.81-33.04 c-1.37-7.22-3.04-16.02-1.57-26.92C110.54,227.16,119.21,214.69,125.36,207.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_990_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1268_",
    className: "st20",
    d: "M125.36,207.57c1.22,36.3,2.44,72.59,3.65,108.89c7.1-11.94,10.75-22.75,12.73-30.37 c1.56-5.99,3.64-14.25,3.55-25.34c-0.13-15.29-4.33-26.52-5.64-29.83C135.48,220.38,129.82,212.65,125.36,207.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_991_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_992_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1265_",
    className: "st19",
    d: "M208.5,192.04c-0.06,14.78-1.95,45.12-17.36,72.17c-8.99,15.78-22.48,29.63-27.98,35.33 c-7.18,7.44-13.55,12.98-18.2,16.77c0.3-4.62,0.85-10.93,1.96-18.41c3.51-23.73,9.89-40.93,11.22-44.47 c3.36-8.95,7.46-19.88,15.21-31.16C185.43,204.67,199.54,196.15,208.5,192.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_993_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1263_",
    className: "st20",
    d: "M208.5,192.04c-21.17,41.45-42.35,82.9-63.52,124.35c12.61-8.9,21.94-18.73,28.06-26.01 c4.82-5.73,11.41-13.67,18.09-26.17c9.2-17.22,12.88-32.46,13.91-37C208.31,212.78,208.76,200.54,208.5,192.04z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1043_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1044_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1260_",
    className: "st19",
    d: "M165.76,431.18c7.34,9.04,20.81,28.52,20.33,53.03c-0.28,14.3-5.62,29.76-7.77,36.1 c-2.81,8.27-5.83,14.96-8.16,19.7c-2.04-2.97-4.69-7.11-7.43-12.24c-8.68-16.3-11.49-30.1-12.05-32.95 c-1.42-7.21-3.16-16-1.77-26.91C151.08,450.88,159.65,438.34,165.76,431.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1045_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1258_",
    className: "st20",
    d: "M165.76,431.18c1.49,36.29,2.97,72.57,4.46,108.86c7.01-11.99,10.58-22.83,12.51-30.46 c1.51-6,3.54-14.27,3.36-25.37c-0.25-15.29-4.53-26.49-5.86-29.79C175.97,443.92,170.24,436.22,165.76,431.18z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1255_",
    className: "st19",
    d: "M94.56,462c10.91,4.07,32.4,14.02,44.42,35.39c7.01,12.47,10.25,28.49,11.62,35.05 c1.78,8.55,2.57,15.85,2.96,21.12c-3.27-1.53-7.65-3.74-12.61-6.78c-15.75-9.64-25.17-20.11-27.1-22.28 c-4.89-5.5-10.85-12.2-15.18-22.3C91.91,486.43,92.94,471.28,94.56,462z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1048_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1253_",
    className: "st20",
    d: "M94.56,462c19.69,30.52,39.38,61.03,59.07,91.55c-0.04-13.89-2.46-25.04-4.67-32.6 c-1.74-5.94-4.19-14.09-9.97-23.56c-7.97-13.05-17.34-20.53-20.17-22.7C109.83,467.8,100.99,464.07,94.56,462z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1049_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1050_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1250_",
    className: "st19",
    d: "M153.63,507.78c8.36,8.11,24.04,25.86,26.46,50.25c1.41,14.23-2.06,30.21-3.44,36.76 c-1.81,8.55-4.01,15.55-5.77,20.53c-2.38-2.71-5.5-6.5-8.83-11.28c-10.55-15.16-14.97-28.53-15.87-31.29 c-2.27-6.99-5.03-15.51-4.94-26.51C141.39,529.08,148.42,515.62,153.63,507.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1248_",
    className: "st20",
    d: "M153.63,507.78c5.77,35.86,11.54,71.71,17.31,107.57c5.55-12.73,7.81-23.92,8.82-31.73 c0.79-6.14,1.83-14.59,0.33-25.59c-2.05-15.15-7.63-25.77-9.35-28.89C165.28,519.22,158.69,512.26,153.63,507.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1052_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1245_",
    className: "st19",
    d: "M201.49,664.48c10.93-4.03,33.71-10.49,56.75-2.12c13.44,4.88,26.35,14.92,31.66,19.01 c6.92,5.33,12.28,10.35,16.01,14.08c-3.47,0.97-8.24,2.15-13.98,3.08c-18.23,2.96-32.19,1.15-35.08,0.77 c-7.28-0.98-16.17-2.17-26.04-7.02C215.4,684.73,206.3,672.57,201.49,664.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1054_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1243_",
    className: "st20",
    d: "M201.49,664.48c34.82,10.31,69.65,20.62,104.47,30.92 c-9.08-10.51-18.19-17.39-24.79-21.67c-5.19-3.37-12.37-7.96-22.92-11.37c-14.55-4.7-26.53-4.27-30.09-4.07 C216.85,658.93,207.72,661.86,201.49,664.48z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1056_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1240_",
    className: "st19",
    d: "M184.02,539.8c8.74,7.7,25.25,24.68,28.83,48.93c2.09,14.15-0.61,30.28-1.68,36.89 c-1.4,8.62-3.27,15.72-4.79,20.78c-2.51-2.59-5.81-6.23-9.35-10.84c-11.26-14.63-16.31-27.78-17.34-30.5 c-2.6-6.87-5.77-15.26-6.2-26.24C172.82,561.66,179.19,547.88,184.02,539.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1057_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1238_",
    className: "st20",
    d: "M184.02,539.8c7.48,35.54,14.95,71.08,22.43,106.62c4.93-12.98,6.66-24.27,7.29-32.11 c0.5-6.17,1.13-14.66-0.89-25.57c-2.78-15.03-8.85-25.37-10.72-28.41C196.21,550.68,189.29,544.04,184.02,539.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1058_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1059_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1235_",
    className: "st19",
    d: "M95.87,521.58c11.3,2.81,33.77,10.29,48.12,30.17c8.37,11.6,13.39,27.16,15.48,33.52 c2.73,8.3,4.34,15.46,5.31,20.65c-3.42-1.15-8.02-2.86-13.29-5.32c-16.73-7.81-27.27-17.15-29.44-19.09 c-5.47-4.9-12.14-10.89-17.58-20.45C95.99,546.15,95.3,530.98,95.87,521.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1060_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1233_",
    className: "st20",
    d: "M95.87,521.58c23,28.11,45.99,56.22,68.99,84.32c-1.6-13.8-5.26-24.61-8.31-31.86 c-2.4-5.71-5.75-13.53-12.56-22.29c-9.38-12.07-19.54-18.45-22.59-20.28C111.69,525.63,102.49,522.91,95.87,521.58z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1061_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1062_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1230_",
    className: "st19",
    d: "M163.27,339.13c5.99,9.99,16.57,31.18,12.63,55.37c-2.3,14.12-9.77,28.66-12.8,34.64 c-3.95,7.79-7.88,13.99-10.87,18.35c-1.6-3.23-3.64-7.7-5.62-13.17c-6.29-17.36-7.12-31.42-7.27-34.32 c-0.39-7.34-0.87-16.29,2.06-26.89C145.96,356.56,156.22,345.36,163.27,339.13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1063_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1228_",
    className: "st20",
    d: "M163.27,339.13c-3.66,36.13-7.32,72.26-10.98,108.4c8.64-10.88,13.71-21.11,16.69-28.39 c2.35-5.73,5.52-13.63,6.91-24.64c1.92-15.17-0.74-26.86-1.59-30.32C171.58,353.19,167.01,344.76,163.27,339.13z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1064_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1065_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1225_",
    className: "st19",
    d: "M192.3,265.83c1.74,11.52,3.48,35.14-9.36,56.02c-7.49,12.18-19.93,22.8-25,27.18 c-6.61,5.71-12.61,9.94-17.02,12.84c-0.25-3.6-0.44-8.51-0.2-14.32c0.78-18.45,5.36-31.77,6.32-34.51 c2.43-6.93,5.39-15.4,12.12-24.09C169.66,275.38,183.41,268.91,192.3,265.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1066_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1223_",
    className: "st20",
    d: "M192.3,265.83c-17.11,32.03-34.23,64.06-51.34,96.09c12.12-6.78,20.7-14.31,26.22-19.91 c4.35-4.41,10.29-10.51,15.76-20.16c7.54-13.3,9.53-25.13,10.05-28.65C194.64,281.99,193.61,272.46,192.3,265.83z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1067_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1068_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1220_",
    className: "st19",
    d: "M103.75,289.18c10.11,5.78,29.71,19.07,38.12,42.1c4.91,13.43,5.52,29.78,5.8,36.47 c0.37,8.73-0.02,16.06-0.49,21.32c-2.98-2.03-6.95-4.93-11.35-8.73c-13.99-12.06-21.59-23.91-23.14-26.37 c-3.93-6.21-8.73-13.78-11.37-24.45C97.19,312.86,100.65,298.07,103.75,289.18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1218_",
    className: "st20",
    d: "M103.75,289.18c14.5,33.3,29,66.59,43.5,99.89c2.21-13.71,1.62-25.11,0.65-32.92 c-0.76-6.14-1.86-14.59-6.04-24.87c-5.76-14.16-13.79-23.06-16.23-25.66C117.88,297.38,109.76,292.27,103.75,289.18z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1070_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    className: "st19",
    d: "M98.74,427.48c10.74,4.51,31.8,15.34,42.93,37.18c6.49,12.74,9.08,28.89,10.17,35.5 c1.42,8.62,1.92,15.94,2.09,21.22c-3.2-1.66-7.49-4.05-12.32-7.29c-15.34-10.28-24.32-21.13-26.16-23.38 c-4.65-5.68-10.33-12.62-14.25-22.9C95.09,451.77,96.74,436.67,98.74,427.48z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1072_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1213_",
    className: "st20",
    d: "M98.74,427.48c18.42,31.3,36.84,62.6,55.26,93.89c0.53-13.88-1.43-25.12-3.33-32.76 c-1.5-6.01-3.61-14.25-9-23.95c-7.43-13.36-16.48-21.22-19.22-23.51C113.75,433.9,105.08,429.81,98.74,427.48z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1073_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1074_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1210_",
    className: "st19",
    d: "M99.22,342.16c12.08,8.29,35.51,26.92,45.81,55.99c6.01,16.96,6.96,36.93,7.39,45.11 c0.56,10.67,0.2,19.54-0.29,25.88c-3.56-2.85-8.31-6.87-13.59-12.04c-16.76-16.42-25.94-31.79-27.82-34.98 c-4.75-8.04-10.55-17.86-13.83-31.18C91.77,370.16,95.67,352.59,99.22,342.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1075_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1208_",
    className: "st20",
    d: "M99.22,342.16c17.67,42.33,35.33,84.67,53,127c2.43-16.41,1.57-30.36,0.32-39.99 c-0.98-7.57-2.41-17.99-7.51-31.02c-7.02-17.96-16.68-29.79-19.62-33.25C116.1,353.89,106.4,346.66,99.22,342.16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1076_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1077_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1205_",
    className: "st19",
    d: "M120.19,582.7c11.55-1.5,35.2-2.72,55.8,10.57c12.02,7.75,22.37,20.41,26.63,25.58 c5.56,6.74,9.67,12.82,12.47,17.29c-3.6,0.17-8.51,0.26-14.32-0.11c-18.43-1.18-31.64-6.04-34.37-7.06 c-6.88-2.58-15.28-5.72-23.82-12.64C129.25,605.54,123.08,591.66,120.19,582.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1078_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1203_",
    className: "st20",
    d: "M120.19,582.7c31.66,17.8,63.31,35.6,94.97,53.4c-6.51-12.27-13.86-21-19.35-26.65 c-4.31-4.44-10.28-10.51-19.82-16.19c-13.14-7.82-24.92-10.06-28.43-10.66C136.4,580.71,126.84,581.54,120.19,582.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1079_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1080_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1200_",
    className: "st19",
    d: "M141.43,630.11c10.97-3.92,33.82-10.14,56.77-1.54c13.39,5.02,26.19,15.19,31.46,19.33 c6.87,5.4,12.17,10.47,15.86,14.25c-3.48,0.94-8.26,2.06-14.02,2.94c-18.26,2.77-32.2,0.82-35.08,0.41 c-7.27-1.05-16.14-2.34-25.96-7.28C155.14,650.51,146.16,638.25,141.43,630.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1081_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1198_",
    className: "st20",
    d: "M141.43,630.11c34.72,10.66,69.43,21.33,104.15,31.99 c-8.97-10.6-18.01-17.57-24.57-21.93c-5.16-3.42-12.28-8.08-22.81-11.6c-14.5-4.85-26.49-4.54-30.05-4.38 C156.85,624.72,147.69,627.56,141.43,630.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1082_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1195_",
    className: "st19",
    d: "M204.1,591.66c11.08,3.59,32.99,12.59,45.93,33.41c7.55,12.15,11.49,28.02,13.14,34.51 c2.15,8.47,3.26,15.72,3.88,20.97c-3.33-1.38-7.81-3.41-12.9-6.22c-16.16-8.94-26.02-18.99-28.05-21.08 c-5.12-5.27-11.36-11.7-16.13-21.61C202.52,616.18,202.88,600.99,204.1,591.66z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1084_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1193_",
    className: "st20",
    d: "M204.1,591.66c21,29.63,42.01,59.25,63.01,88.88c-0.64-13.87-3.55-24.91-6.09-32.36 c-2-5.86-4.8-13.9-10.99-23.11c-8.53-12.69-18.22-19.75-21.14-21.79C219.6,596.79,210.61,593.45,204.1,591.66z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1085_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1086_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1087_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1088_",
    d: "M373.08,654.41c-0.7,1.9-1.63,3.49-2.81,4.77c-1.18,1.29-2.53,2.24-4.05,2.87 c-1.53,0.63-3.14,0.95-4.84,0.95c-1.39,0-2.7-0.16-3.92-0.49s-2.46-0.92-3.72-1.8v15.93c0,0.13-0.07,0.35-0.2,0.65 c-0.13,0.31-0.44,0.46-0.91,0.46h-7.18c-0.48,0-0.79-0.14-0.95-0.43c-0.15-0.28-0.23-0.53-0.23-0.75v-38.72 c0-0.56,0.56-1.05,1.7-1.47s2.48-0.75,4.05-1.02s3.16-0.46,4.77-0.58c1.61-0.13,2.9-0.2,3.85-0.2c2.61,0,4.89,0.32,6.82,0.98 c1.94,0.65,3.55,1.57,4.84,2.74c1.28,1.17,2.24,2.58,2.87,4.21s0.95,3.41,0.95,5.32C374.13,650.33,373.78,652.52,373.08,654.41z  M362.86,641.51c-0.98-1.48-2.75-2.21-5.32-2.21c-0.56,0-1.25,0.05-2.06,0.16c-0.8,0.11-1.38,0.21-1.73,0.29v16.27 c0.74,0.48,1.48,0.88,2.22,1.21c0.74,0.32,1.4,0.49,1.96,0.49c1.09,0,2.04-0.15,2.84-0.46c0.8-0.3,1.47-0.81,1.99-1.53 c0.53-0.71,0.91-1.68,1.18-2.9c0.26-1.21,0.39-2.75,0.39-4.62C364.33,645.21,363.84,642.98,362.86,641.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1091_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1092_",
    d: "M411.7,674.13c1.2-0.32,2.3-0.69,3.29-1.07c0.48,0.04,0.86,0.27,1.14,0.69 c0.29,0.41,0.43,0.88,0.43,1.4c0,0.44-0.09,0.8-0.26,1.11c-2.92,1.52-6.51,2.29-10.77,2.29c-2.05,0-3.93-0.34-5.65-1.02 c-1.72-0.67-2.93-1.86-3.62-3.56c-1.18,1.7-2.46,2.88-3.85,3.56c-1.4,0.67-2.9,1.02-4.51,1.02c-2.18,0-4.03-0.49-5.55-1.47 c-1.53-0.98-2.77-2.23-3.75-3.75c-0.98-1.53-1.7-3.21-2.16-5.06s-0.69-3.67-0.69-5.45c0-2.17,0.28-4.21,0.85-6.11 c0.56-1.89,1.42-3.53,2.58-4.93c1.15-1.39,2.64-2.49,4.44-3.3c1.81-0.8,3.95-1.21,6.43-1.21c4.84,0,8.41,1.21,10.75,3.62 c2.33,2.41,3.49,5.87,3.49,10.35v8.56c0,1.92,0.4,3.2,1.21,3.85c0.81,0.65,1.77,0.98,2.91,0.98 C409.41,674.62,410.5,674.46,411.7,674.13z M395.28,661.17c0-0.91-0.04-1.91-0.13-3s-0.31-2.11-0.65-3.07 c-0.35-0.96-0.87-1.75-1.57-2.38s-1.68-0.95-2.94-0.95c-1.17,0-2.12,0.4-2.84,1.21s-1.25,1.77-1.6,2.91 c-0.35,1.13-0.57,2.33-0.69,3.59c-0.11,1.26-0.16,2.35-0.16,3.26s0.03,1.98,0.1,3.2c0.06,1.22,0.26,2.39,0.59,3.5 c0.32,1.11,0.82,2.05,1.5,2.81c0.67,0.76,1.6,1.14,2.78,1.14c0.96,0,1.94-0.35,2.97-1.05c1.02-0.7,1.9-1.52,2.64-2.48V661.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1096_",
    d: "M428.75,650.92c-0.2,0.39-0.55,0.7-1.08,0.91h-5.62c-0.22,2.66-0.41,5.26-0.58,7.8 c-0.18,2.55-0.26,5.15-0.26,7.81c0,2.17,0.32,3.88,0.98,5.12c0.65,1.24,1.74,1.87,3.26,1.87c1.05,0,2.25-0.16,3.62-0.49 c1.38-0.32,2.56-0.79,3.56-1.4c0.7,0,1.19,0.25,1.47,0.75s0.43,0.99,0.43,1.47c0,0.39-0.07,0.67-0.2,0.85 c-1.05,0.74-2.16,1.31-3.33,1.7c-1.17,0.39-2.35,0.67-3.53,0.85c-1.17,0.18-2.29,0.28-3.33,0.32c-1.05,0.04-1.96,0.07-2.74,0.07 c-1.83,0-3.32-0.26-4.47-0.75c-1.15-0.5-2.07-1.28-2.74-2.35c-0.67-1.07-1.13-2.43-1.37-4.08s-0.36-3.63-0.36-5.94 c0-2.22,0.09-4.49,0.26-6.79c0.18-2.31,0.33-4.57,0.46-6.79h-2.67c-0.48-0.22-0.82-0.52-1.02-0.91s-0.29-0.76-0.29-1.11 s0.1-0.72,0.29-1.11s0.53-0.7,1.02-0.91h3.13l2.48-7.64c0.13-0.43,0.3-0.8,0.49-1.11c0.2-0.3,0.56-0.46,1.08-0.46h3.92 c1,0,1.5,0.41,1.5,1.24l-0.78,7.97h5.35c0.44,0.22,0.78,0.52,1.01,0.91c0.24,0.39,0.36,0.77,0.36,1.11 C429.04,650.16,428.94,650.52,428.75,650.92z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1098_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1099_",
    d: "M458.75,669.79c0,1.92,0.4,3.2,1.21,3.85c0.8,0.65,1.77,0.98,2.9,0.98c1.4,0,2.66-0.16,3.79-0.49 c1.13-0.32,2.2-0.69,3.2-1.07c0.48,0.04,0.86,0.27,1.14,0.69c0.29,0.41,0.43,0.88,0.43,1.4c0,0.44-0.09,0.8-0.26,1.11 c-2.92,1.52-6.51,2.29-10.77,2.29c-2.05,0-3.93-0.34-5.65-1.02c-1.72-0.67-2.93-1.86-3.62-3.56c-1.35,1.65-2.77,2.83-4.25,3.52 c-1.48,0.7-3.05,1.05-4.7,1.05c-2.05,0-3.66-0.32-4.83-0.95c-1.17-0.63-2.07-1.47-2.68-2.52c-0.61-1.04-0.99-2.26-1.14-3.66 c-0.15-1.39-0.23-2.87-0.23-4.44v-17.63c0-0.44,0.1-0.79,0.29-1.08c0.2-0.28,0.6-0.43,1.21-0.43h6.01 c0.61,0,1.02,0.14,1.21,0.43c0.2,0.29,0.32,0.64,0.36,1.08v19.85c0,0.87,0.06,1.58,0.2,2.12c0.13,0.54,0.3,0.97,0.52,1.27 c0.22,0.31,0.47,0.52,0.75,0.62c0.28,0.11,0.6,0.16,0.95,0.16c0.61,0,1.41-0.36,2.41-1.08c1-0.72,1.85-1.58,2.55-2.58v-20.37 c0-0.44,0.1-0.79,0.29-1.08c0.2-0.28,0.6-0.43,1.21-0.43h5.94c0.61,0,1.03,0.14,1.24,0.43c0.22,0.29,0.32,0.64,0.32,1.08V669.79 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1101_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1102_",
    d: "M506.75,669.79c0,1.92,0.39,3.2,1.17,3.85c0.79,0.65,1.76,0.98,2.94,0.98c1,0,2.09-0.16,3.27-0.49 c1.17-0.32,2.26-0.69,3.26-1.07c0.61,0.09,1.04,0.35,1.28,0.78c0.24,0.44,0.36,0.89,0.36,1.37s-0.09,0.83-0.26,1.05 c-1.83,0.91-3.62,1.52-5.39,1.83c-1.76,0.3-3.56,0.46-5.38,0.46c-2.22,0-4.01-0.29-5.36-0.85c-1.35-0.56-2.39-1.36-3.1-2.39 c-0.72-1.02-1.2-2.23-1.43-3.62c-0.24-1.39-0.36-2.93-0.36-4.63v-9.21c0-1.96-0.13-3.35-0.39-4.18 c-0.27-0.83-0.77-1.24-1.5-1.24c-0.61,0-1.32,0.33-2.12,1.01c-0.81,0.67-1.58,1.51-2.32,2.51v20.31c0,0.44-0.11,0.79-0.32,1.07 c-0.22,0.29-0.63,0.43-1.24,0.43h-5.88c-0.61,0-1.03-0.14-1.24-0.43c-0.22-0.28-0.32-0.64-0.32-1.07v-19.2 c0-1.7-0.16-2.9-0.49-3.59c-0.33-0.7-0.75-1.04-1.28-1.04c-0.79,0-1.57,0.33-2.35,1.01c-0.79,0.67-1.53,1.51-2.22,2.51v20.31 c0,0.44-0.1,0.79-0.3,1.07c-0.19,0.29-0.6,0.43-1.21,0.43h-5.94c-0.61,0-1.03-0.14-1.24-0.43c-0.22-0.28-0.32-0.64-0.32-1.07 v-26.97c0-0.44,0.11-0.8,0.32-1.08c0.22-0.28,0.63-0.43,1.24-0.43h5.94c0.61,0,1.02,0.14,1.21,0.43c0.2,0.28,0.3,0.64,0.3,1.08 v1.37c0.74-0.91,1.73-1.71,2.97-2.39c1.24-0.67,2.62-1.01,4.15-1.01s3,0.3,4.44,0.91c1.43,0.61,2.52,1.63,3.26,3.07 c1-1.08,2.06-2.02,3.17-2.81c1.11-0.79,2.58-1.17,4.41-1.17c1.96,0,3.49,0.27,4.6,0.81c1.11,0.55,1.93,1.33,2.48,2.35 c0.54,1.02,0.88,2.24,1.01,3.66c0.13,1.41,0.2,2.97,0.2,4.67v11.04H506.75z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1104_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1106_",
    d: "M342.45,732.78h2.22c0.35,0.21,0.6,0.5,0.75,0.85s0.23,0.71,0.23,1.11c0,0.48-0.08,0.9-0.23,1.28 c-0.15,0.37-0.4,0.64-0.75,0.82h-14.3c-0.35-0.18-0.6-0.45-0.75-0.82s-0.23-0.8-0.23-1.28c0-0.39,0.07-0.76,0.23-1.11 c0.15-0.35,0.4-0.64,0.75-0.85h2.55v-34.61h-2.55c-0.35-0.22-0.6-0.5-0.75-0.84c-0.15-0.35-0.23-0.72-0.23-1.12 c0-0.48,0.07-0.9,0.23-1.28c0.15-0.37,0.4-0.64,0.75-0.81h14.3c0.35,0.18,0.6,0.45,0.75,0.81c0.15,0.37,0.23,0.8,0.23,1.28 c0,0.39-0.08,0.77-0.23,1.12c-0.15,0.35-0.4,0.63-0.75,0.84h-2.22V732.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1108_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1109_",
    d: "M376.01,728.86c0,1.92,0.39,3.2,1.17,3.86c0.79,0.65,1.76,0.98,2.94,0.98c1,0,2.09-0.16,3.27-0.49 c1.17-0.33,2.26-0.69,3.26-1.08c0.61,0.09,1.03,0.35,1.28,0.78c0.24,0.44,0.36,0.89,0.36,1.37s-0.09,0.83-0.26,1.05 c-1.83,0.91-3.62,1.53-5.39,1.83s-3.56,0.46-5.38,0.46c-2.22,0-4.01-0.28-5.36-0.85c-1.35-0.56-2.39-1.36-3.1-2.39 c-0.72-1.02-1.2-2.23-1.43-3.62c-0.24-1.39-0.36-2.93-0.36-4.63v-9.2c0-2-0.22-3.41-0.65-4.21c-0.44-0.8-0.98-1.21-1.63-1.21 c-0.74,0-1.6,0.34-2.58,1.01c-0.98,0.68-1.82,1.51-2.51,2.52v20.31c0,0.44-0.11,0.79-0.33,1.08c-0.22,0.28-0.61,0.43-1.17,0.43 h-6.01c-0.57,0-0.96-0.14-1.18-0.43s-0.32-0.64-0.32-1.08v-26.97c0-0.44,0.11-0.8,0.32-1.08c0.22-0.28,0.61-0.42,1.18-0.42h6.01 c0.56,0,0.96,0.14,1.17,0.42c0.22,0.28,0.33,0.64,0.33,1.08v1.37c1-1.17,2.12-2.04,3.36-2.58c1.24-0.54,2.66-0.81,4.27-0.81 c2.05,0,3.65,0.3,4.8,0.91s2.02,1.44,2.61,2.48s0.96,2.26,1.11,3.66c0.15,1.39,0.23,2.88,0.23,4.44L376.01,728.86L376.01,728.86 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1111_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1112_",
    d: "M394.77,721.91c-1.21,0.58-2.13,1.23-2.73,1.92v25.73c0,0.39-0.06,0.72-0.2,0.98 c-0.13,0.26-0.43,0.46-0.91,0.58l-4.42,0.85c-0.57,0-0.91-0.15-1.04-0.46c-0.13-0.3-0.22-0.63-0.26-0.98l-2.67-35.59 c-0.09-1.05-0.15-2.12-0.2-3.23s-0.06-2.23-0.06-3.36c0-2.22,0.14-4.4,0.42-6.53s0.78-4.04,1.5-5.74s1.71-3.07,2.99-4.11 c1.28-1.05,2.94-1.57,4.98-1.57c2.43,0,4.34,0.86,5.72,2.58c1.39,1.72,2.08,4,2.08,6.82c0,1.48-0.14,3.16-0.43,5.03 s-0.73,3.84-1.33,5.88c-0.48,1.66-1.07,3.18-1.79,4.57c-0.71,1.39-1.59,2.66-2.63,3.79c0.56-0.26,1.36-0.56,2.38-0.91 c1.02-0.35,1.88-0.52,2.57-0.52c0.7,0.3,1.04,0.87,1.04,1.7c0,0.48-0.15,0.87-0.46,1.18 C397.5,720.85,395.99,721.32,394.77,721.91z M391.36,718.28c0.74-1.74,1.39-3.53,1.96-5.36c0.57-1.83,1.04-3.6,1.41-5.32 c0.37-1.72,0.65-3.33,0.84-4.83c0.2-1.51,0.3-2.82,0.3-3.95c0-0.87-0.2-1.64-0.59-2.29c-0.39-0.65-0.85-0.98-1.37-0.98 c-0.39,0-0.78,0.26-1.17,0.78s-0.7,1.46-0.91,2.81c-0.22,1.3-0.35,2.88-0.39,4.73s-0.06,3.82-0.06,5.91v8.5H391.36z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    d: "M438.34,733.21c1.2-0.33,2.3-0.69,3.29-1.08c0.48,0.04,0.86,0.27,1.14,0.69 c0.29,0.41,0.43,0.88,0.43,1.4c0,0.44-0.09,0.81-0.26,1.11c-2.92,1.53-6.51,2.29-10.77,2.29c-2.05,0-3.93-0.33-5.65-1.02 c-1.72-0.67-2.93-1.86-3.62-3.56c-1.18,1.7-2.46,2.89-3.85,3.56c-1.4,0.68-2.9,1.02-4.51,1.02c-2.18,0-4.03-0.49-5.55-1.47 c-1.53-0.98-2.77-2.23-3.75-3.75s-1.7-3.21-2.16-5.06s-0.69-3.67-0.69-5.45c0-2.18,0.28-4.21,0.85-6.11 c0.56-1.89,1.42-3.53,2.58-4.93s2.64-2.49,4.44-3.3c1.81-0.8,3.95-1.21,6.43-1.21c4.84,0,8.41,1.21,10.75,3.62 c2.33,2.42,3.49,5.87,3.49,10.35v8.56c0,1.92,0.4,3.2,1.21,3.86c0.81,0.65,1.77,0.98,2.91,0.98 C436.05,733.7,437.14,733.53,438.34,733.21z M421.92,720.24c0-0.91-0.04-1.91-0.13-3s-0.31-2.11-0.65-3.07 c-0.35-0.96-0.87-1.75-1.57-2.39s-1.68-0.95-2.94-0.95c-1.17,0-2.12,0.4-2.84,1.21s-1.25,1.77-1.6,2.91 c-0.35,1.13-0.57,2.33-0.69,3.59c-0.11,1.26-0.16,2.35-0.16,3.27c0,0.91,0.03,1.98,0.1,3.2c0.06,1.22,0.26,2.38,0.59,3.49 c0.32,1.11,0.82,2.05,1.5,2.81c0.67,0.76,1.6,1.14,2.78,1.14c0.96,0,1.94-0.35,2.97-1.04c1.02-0.7,1.9-1.53,2.64-2.49V720.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1119_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1120_",
    d: "M464.23,728.86c0,1.92,0.39,3.2,1.17,3.86c0.79,0.65,1.76,0.98,2.94,0.98c1,0,2.09-0.16,3.27-0.49 c1.17-0.33,2.26-0.69,3.26-1.08c0.61,0.09,1.03,0.35,1.28,0.78c0.24,0.44,0.36,0.89,0.36,1.37s-0.09,0.83-0.26,1.05 c-1.83,0.91-3.62,1.53-5.39,1.83s-3.56,0.46-5.38,0.46c-2.22,0-4.01-0.28-5.36-0.85c-1.35-0.56-2.39-1.36-3.1-2.39 c-0.72-1.02-1.2-2.23-1.43-3.62c-0.24-1.39-0.36-2.93-0.36-4.63v-9.2c0-2-0.22-3.41-0.65-4.21c-0.44-0.8-0.98-1.21-1.63-1.21 c-0.74,0-1.6,0.34-2.58,1.01c-0.98,0.68-1.82,1.51-2.51,2.52v20.31c0,0.44-0.11,0.79-0.33,1.08c-0.22,0.28-0.61,0.43-1.17,0.43 h-6.01c-0.57,0-0.96-0.14-1.18-0.43s-0.32-0.64-0.32-1.08v-26.97c0-0.44,0.11-0.8,0.32-1.08c0.22-0.28,0.61-0.42,1.18-0.42h6.01 c0.56,0,0.96,0.14,1.17,0.42c0.22,0.28,0.33,0.64,0.33,1.08v1.37c1-1.17,2.12-2.04,3.36-2.58c1.24-0.54,2.66-0.81,4.27-0.81 c2.05,0,3.65,0.3,4.8,0.91s2.02,1.44,2.61,2.48s0.96,2.26,1.11,3.66c0.15,1.39,0.23,2.88,0.23,4.44L464.23,728.86L464.23,728.86 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1122_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1123_",
    d: "M488.69,709.99c-0.2,0.39-0.55,0.7-1.08,0.91h-5.62c-0.22,2.66-0.41,5.26-0.58,7.81 c-0.18,2.55-0.26,5.14-0.26,7.8c0,2.18,0.32,3.88,0.98,5.12c0.65,1.24,1.74,1.87,3.26,1.87c1.05,0,2.25-0.16,3.62-0.49 c1.38-0.32,2.56-0.79,3.56-1.4c0.7,0,1.19,0.26,1.47,0.75c0.28,0.5,0.43,0.99,0.43,1.47c0,0.39-0.07,0.68-0.2,0.85 c-1.05,0.74-2.16,1.31-3.33,1.7c-1.17,0.39-2.35,0.67-3.53,0.84c-1.17,0.18-2.29,0.28-3.33,0.32c-1.05,0.04-1.96,0.07-2.74,0.07 c-1.83,0-3.32-0.25-4.47-0.75s-2.07-1.29-2.74-2.35c-0.67-1.07-1.13-2.43-1.37-4.08c-0.24-1.66-0.36-3.63-0.36-5.95 c0-2.22,0.09-4.48,0.26-6.79c0.18-2.31,0.33-4.57,0.46-6.79h-2.67c-0.48-0.22-0.82-0.52-1.02-0.91 c-0.2-0.39-0.29-0.76-0.29-1.11s0.1-0.72,0.29-1.11c0.2-0.39,0.53-0.7,1.02-0.91h3.13l2.48-7.64c0.13-0.44,0.3-0.81,0.49-1.12 c0.2-0.3,0.56-0.46,1.08-0.46h3.92c1,0,1.5,0.41,1.5,1.24l-0.78,7.97h5.35c0.44,0.21,0.78,0.52,1.02,0.91 c0.24,0.39,0.36,0.76,0.36,1.11C488.98,709.23,488.89,709.6,488.69,709.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1125_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1126_",
    d: "M501.85,707.25c0.22,0.26,0.32,0.63,0.32,1.11c-0.22,3-0.44,5.86-0.65,8.56 c-0.22,2.7-0.33,5.48-0.33,8.35c0,0.62,0,1.22,0,1.83c0,0.57,0.02,1.16,0.06,1.76c0,1.92,0.39,3.2,1.18,3.86 c0.78,0.65,1.76,0.98,2.94,0.98c1,0,2.09-0.16,3.26-0.49s2.26-0.69,3.26-1.08c0.61,0.09,1.04,0.35,1.28,0.78 c0.24,0.44,0.36,0.89,0.36,1.37s-0.09,0.83-0.27,1.05c-1.83,0.91-3.62,1.53-5.38,1.83s-3.56,0.46-5.39,0.46 c-2.48,0-4.4-0.36-5.74-1.08c-1.35-0.72-2.34-1.68-2.98-2.9c-0.63-1.22-1-2.63-1.11-4.21c-0.11-1.59-0.16-3.26-0.16-5 c0-2.48,0.05-5.14,0.16-7.97c0.11-2.83,0.33-5.53,0.69-8.1c0.09-0.48,0.21-0.85,0.39-1.11c0.18-0.26,0.57-0.39,1.17-0.39h5.69 C501.22,706.86,501.63,706.99,501.85,707.25z M501.62,700.59c-0.89,0.83-1.92,1.24-3.1,1.24c-1.22,0-2.26-0.41-3.13-1.24 s-1.31-1.85-1.31-3.07c0-1.17,0.44-2.17,1.31-2.97s1.91-1.21,3.13-1.21c1.18,0,2.21,0.4,3.1,1.21s1.34,1.8,1.34,2.97 C502.96,698.74,502.51,699.76,501.62,700.59z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1130_",
    d: "M528.2,704.18c-0.5,2.13-1.21,4.34-2.12,6.62c-0.91,2.29-2,4.6-3.26,6.93s-2.64,4.56-4.12,6.69 c0.13,1.35,0.33,2.58,0.59,3.69s0.61,2.07,1.05,2.88c0.43,0.81,0.98,1.42,1.63,1.86s1.41,0.65,2.29,0.65 c0.52,0,1.13-0.08,1.83-0.23c0.7-0.15,1.4-0.35,2.12-0.59c0.72-0.24,1.43-0.51,2.13-0.81c0.7-0.31,1.28-0.61,1.76-0.91 c0.74,0.09,1.23,0.36,1.47,0.81s0.36,0.93,0.36,1.41c0,0.3-0.05,0.58-0.13,0.84c-1.05,0.74-2.19,1.34-3.43,1.8 c-1.24,0.46-2.49,0.81-3.76,1.08c-1.26,0.26-2.45,0.45-3.56,0.55c-1.11,0.11-2.06,0.16-2.84,0.16c-2.13,0-3.86-0.41-5.19-1.24 s-2.36-2-3.1-3.5c-0.74-1.5-1.24-3.33-1.5-5.48c-0.26-2.16-0.39-4.56-0.39-7.22c0-1.43,0.04-3.18,0.13-5.22 c0.09-2.05,0.26-4.17,0.52-6.37c0.26-2.19,0.65-4.38,1.17-6.56c0.52-2.18,1.22-4.13,2.09-5.88c0.87-1.74,1.96-3.15,3.27-4.21 c1.31-1.07,2.87-1.6,4.7-1.6c2.22,0,3.95,0.69,5.19,2.06s1.87,3.36,1.87,5.97C528.95,700.11,528.7,702.04,528.2,704.18z  M521.11,696.44c-0.48,1.54-0.88,3.48-1.21,5.81s-0.59,4.84-0.79,7.54c-0.2,2.7-0.33,5.21-0.43,7.51 c0.83-1.74,1.61-3.54,2.35-5.39c0.74-1.85,1.39-3.66,1.96-5.42s1.02-3.41,1.34-4.93c0.33-1.52,0.49-2.81,0.49-3.85 c0-1.44-0.23-2.4-0.69-2.87s-0.92-0.72-1.4-0.72C522.13,694.12,521.59,694.89,521.11,696.44z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1133_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1139_",
    className: "st14",
    d: "M399.23,518.59c12.36,11.83,10.1,33.32-0.78,44c-10.85,10.65-32.33,12.54-43.97,0.02 c-11.47-12.34-7.81-32.69,2.76-42.72C367.48,510.17,387.32,507.18,399.23,518.59z M366.8,523.48c-7.34,7.25-6.98,19.51,0.8,27.4 c7.78,7.88,20.05,8.4,27.39,1.16c7.34-7.25,6.98-19.51-0.8-27.4C386.4,516.75,374.14,516.24,366.8,523.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPatumInfantil);
export default __webpack_public_path__ + "static/media/logo_patum_infantil.cf8dee7b3625130053597b3e029ffaed.svg";
export { ForwardRef as ReactComponent };